import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/icons/arrow.scss';

const propTypes = {
    isLeft: PropTypes.bool,
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    isLeft: false,
    backgroundColor: '#ffffff',
    color: '#25786f',
    className: null,
};

const Arrow = ({ isLeft, backgroundColor, color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <rect
            fill={backgroundColor}
            width="30"
            height="30"
            className={classNames([{ [styles.left]: isLeft }])}
        />
        <g className={classNames([{ [styles.left]: isLeft }])}>
            <path
                fill={backgroundColor}
                d="M12.1,0.3C12.1,0.3,12.1,0.2,12.1,0.3C12.1,0.3,12.1,0.3,12.1,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M13.6,0.2C13.7,0.3,13.7,0.2,13.6,0.2C13.7,0.2,13.7,0.2,13.6,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M8,0.3C8,0.3,8,0.3,8,0.3C8,0.3,8,0.3,8,0.3C8,0.3,8,0.3,8,0.3C8,0.3,8,0.3,8,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M7.9,0.3C7.9,0.2,7.9,0.2,7.9,0.3C7.9,0.2,7.9,0.2,7.9,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M7.7,0.3C7.7,0.3,7.7,0.3,7.7,0.3C7.7,0.3,7.7,0.3,7.7,0.3C7.7,0.2,7.7,0.2,7.7,0.3C7.6,0.3,7.6,0.3,7.7,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M7.4,0.2C7.4,0.2,7.4,0.2,7.4,0.2C7.4,0.2,7.4,0.2,7.4,0.2C7.4,0.2,7.4,0.2,7.4,0.2C7.4,0.2,7.4,0.2,7.4,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M8.8,0.2C8.8,0.2,8.8,0.2,8.8,0.2C8.8,0.2,8.8,0.2,8.8,0.2C8.8,0.2,8.8,0.2,8.8,0.2C8.8,0.2,8.8,0.2,8.8,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M9.2,0.3C9.2,0.3,9.2,0.3,9.2,0.3C9.2,0.3,9.2,0.3,9.2,0.3C9.2,0.3,9.2,0.3,9.2,0.3C9.2,0.3,9.2,0.3,9.2,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M9.6,0.4C9.6,0.4,9.6,0.4,9.6,0.4C9.6,0.4,9.6,0.4,9.6,0.4C9.6,0.4,9.6,0.4,9.6,0.4C9.6,0.4,9.6,0.4,9.6,0.4z"
            />
            <path
                fill={backgroundColor}
                d="M8.7,0.3C8.7,0.3,8.7,0.3,8.7,0.3C8.7,0.3,8.7,0.3,8.7,0.3C8.7,0.3,8.7,0.3,8.7,0.3C8.7,0.3,8.7,0.3,8.7,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M8.6,0.3C8.6,0.3,8.6,0.3,8.6,0.3C8.6,0.3,8.6,0.3,8.6,0.3C8.6,0.3,8.6,0.3,8.6,0.3C8.6,0.3,8.6,0.3,8.6,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M8.8,0.4C8.8,0.4,8.8,0.4,8.8,0.4C8.8,0.4,8.8,0.4,8.8,0.4C8.8,0.4,8.8,0.4,8.8,0.4C8.8,0.4,8.8,0.4,8.8,0.4z"
            />
            <path
                fill={backgroundColor}
                d="M23.6,0.3C23.6,0.3,23.6,0.2,23.6,0.3C23.5,0.3,23.5,0.3,23.6,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M25.1,0.2C25.1,0.3,25.1,0.2,25.1,0.2C25.1,0.2,25.1,0.2,25.1,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M19.4,0.3C19.4,0.3,19.4,0.3,19.4,0.3C19.4,0.3,19.4,0.3,19.4,0.3C19.4,0.3,19.4,0.3,19.4,0.3
    		C19.4,0.3,19.4,0.3,19.4,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M19.3,0.3C19.3,0.2,19.3,0.2,19.3,0.3C19.3,0.2,19.3,0.2,19.3,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M19.1,0.3C19.1,0.3,19.1,0.3,19.1,0.3C19.1,0.3,19.1,0.3,19.1,0.3C19.1,0.2,19.1,0.2,19.1,0.3
    		C19.1,0.3,19.1,0.3,19.1,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M18.8,0.2C18.8,0.2,18.8,0.2,18.8,0.2C18.8,0.2,18.8,0.2,18.8,0.2C18.8,0.2,18.8,0.2,18.8,0.2
    		C18.8,0.2,18.8,0.2,18.8,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M20.2,0.2C20.2,0.2,20.3,0.2,20.2,0.2C20.3,0.2,20.3,0.2,20.2,0.2C20.3,0.2,20.3,0.2,20.2,0.2
    		C20.2,0.2,20.2,0.2,20.2,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M20.6,0.3C20.6,0.3,20.6,0.3,20.6,0.3C20.6,0.3,20.6,0.3,20.6,0.3C20.6,0.3,20.6,0.3,20.6,0.3
    		C20.6,0.3,20.6,0.3,20.6,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M21,0.4C21,0.4,21,0.4,21,0.4C21.1,0.4,21.1,0.4,21,0.4C21.1,0.4,21.1,0.4,21,0.4C21,0.4,21,0.4,21,0.4z"
            />
            <path
                fill={backgroundColor}
                d="M20.1,0.3C20.1,0.3,20.1,0.3,20.1,0.3C20.1,0.3,20.1,0.3,20.1,0.3C20.2,0.3,20.1,0.3,20.1,0.3
    		C20.1,0.3,20.1,0.3,20.1,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M20,0.3C20,0.3,20,0.3,20,0.3C20,0.3,20,0.3,20,0.3C20,0.3,20,0.3,20,0.3C20,0.3,20,0.3,20,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M20.2,0.4C20.2,0.4,20.2,0.4,20.2,0.4C20.2,0.4,20.2,0.4,20.2,0.4C20.2,0.4,20.2,0.4,20.2,0.4
    		C20.2,0.4,20.2,0.4,20.2,0.4z"
            />
            <path
                fill={backgroundColor}
                d="M5.4,0.3C5.4,0.3,5.4,0.2,5.4,0.3C5.4,0.3,5.4,0.3,5.4,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M6.9,0.2C7,0.3,7,0.2,6.9,0.2C6.9,0.2,6.9,0.2,6.9,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M1.2,0.3C1.2,0.3,1.2,0.3,1.2,0.3C1.3,0.3,1.3,0.3,1.2,0.3C1.3,0.3,1.3,0.3,1.2,0.3C1.3,0.3,1.2,0.3,1.2,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M1.1,0.3C1.2,0.2,1.2,0.2,1.1,0.3C1.1,0.2,1.1,0.2,1.1,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M0.9,0.3C0.9,0.3,0.9,0.3,0.9,0.3C0.9,0.3,0.9,0.3,0.9,0.3C0.9,0.2,0.9,0.2,0.9,0.3C0.9,0.3,0.9,0.3,0.9,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M0.6,0.2C0.6,0.2,0.6,0.2,0.6,0.2C0.7,0.2,0.7,0.2,0.6,0.2C0.7,0.2,0.7,0.2,0.6,0.2C0.6,0.2,0.6,0.2,0.6,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M2.1,0.2C2.1,0.2,2.1,0.2,2.1,0.2C2.1,0.2,2.1,0.2,2.1,0.2C2.1,0.2,2.1,0.2,2.1,0.2C2.1,0.2,2.1,0.2,2.1,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M2.4,0.3C2.4,0.3,2.4,0.3,2.4,0.3C2.5,0.3,2.5,0.3,2.4,0.3C2.5,0.3,2.5,0.3,2.4,0.3C2.4,0.3,2.4,0.3,2.4,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M2.9,0.4C2.9,0.4,2.9,0.4,2.9,0.4C2.9,0.4,2.9,0.4,2.9,0.4C2.9,0.4,2.9,0.4,2.9,0.4C2.9,0.4,2.8,0.4,2.9,0.4z"
            />
            <path
                fill={backgroundColor}
                d="M1.9,0.3C1.9,0.3,2,0.3,1.9,0.3C2,0.3,2,0.3,1.9,0.3C2,0.3,2,0.3,1.9,0.3C2,0.3,1.9,0.3,1.9,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M1.9,0.3C1.8,0.3,1.8,0.3,1.9,0.3C1.8,0.3,1.8,0.3,1.9,0.3C1.9,0.3,1.9,0.3,1.9,0.3C1.9,0.3,1.9,0.3,1.9,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M2,0.4C2,0.4,2,0.4,2,0.4C2.1,0.4,2.1,0.4,2,0.4C2.1,0.4,2.1,0.4,2,0.4C2,0.4,2,0.4,2,0.4z"
            />
            <path
                fill={backgroundColor}
                d="M16.9,0.3C16.8,0.3,16.8,0.2,16.9,0.3C16.8,0.3,16.8,0.3,16.9,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M18.4,0.2C18.4,0.3,18.4,0.2,18.4,0.2C18.4,0.2,18.4,0.2,18.4,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M12.7,0.3C12.7,0.3,12.7,0.3,12.7,0.3C12.7,0.3,12.7,0.3,12.7,0.3C12.7,0.3,12.7,0.3,12.7,0.3
    		C12.7,0.3,12.7,0.3,12.7,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M12.6,0.3C12.6,0.2,12.6,0.2,12.6,0.3C12.6,0.2,12.6,0.2,12.6,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M12.4,0.3C12.4,0.3,12.4,0.3,12.4,0.3C12.4,0.3,12.4,0.3,12.4,0.3C12.4,0.2,12.4,0.2,12.4,0.3
    		C12.4,0.3,12.4,0.3,12.4,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M13.5,0.2C13.5,0.2,13.5,0.2,13.5,0.2C13.5,0.2,13.5,0.2,13.5,0.2C13.5,0.2,13.5,0.2,13.5,0.2
    		C13.5,0.2,13.5,0.2,13.5,0.2z"
            />
            <path
                fill={backgroundColor}
                d="M13.9,0.3C13.9,0.3,13.9,0.3,13.9,0.3C13.9,0.3,13.9,0.3,13.9,0.3C13.9,0.3,13.9,0.3,13.9,0.3
    		C13.9,0.3,13.9,0.3,13.9,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M14.3,0.4C14.3,0.4,14.3,0.4,14.3,0.4C14.3,0.4,14.3,0.4,14.3,0.4C14.3,0.4,14.3,0.4,14.3,0.4
    		C14.3,0.4,14.3,0.4,14.3,0.4z"
            />
            <path
                fill={backgroundColor}
                d="M13.4,0.3C13.4,0.3,13.4,0.3,13.4,0.3C13.4,0.3,13.4,0.3,13.4,0.3C13.4,0.3,13.4,0.3,13.4,0.3
    		C13.4,0.3,13.4,0.3,13.4,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M13.3,0.3C13.3,0.3,13.3,0.3,13.3,0.3C13.3,0.3,13.3,0.3,13.3,0.3C13.3,0.3,13.3,0.3,13.3,0.3
    		C13.3,0.3,13.3,0.3,13.3,0.3z"
            />
            <path
                fill={backgroundColor}
                d="M13.5,0.4C13.5,0.4,13.5,0.4,13.5,0.4C13.5,0.4,13.5,0.4,13.5,0.4C13.5,0.4,13.5,0.4,13.5,0.4
    		C13.5,0.4,13.5,0.4,13.5,0.4z"
            />
            <path fill={backgroundColor} d="M29.8,7C29.8,7,29.8,7,29.8,7C29.8,7,29.8,7,29.8,7z" />
            <path
                fill={backgroundColor}
                d="M29.8,9.1C29.8,9,29.8,9,29.8,9.1C29.8,9.1,29.8,9.1,29.8,9.1z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,1.7C29.8,1.7,29.8,1.7,29.8,1.7C29.8,1.7,29.8,1.7,29.8,1.7C29.8,1.7,29.8,1.7,29.8,1.7
    		C29.8,1.7,29.8,1.7,29.8,1.7z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,1.6C29.8,1.5,29.8,1.5,29.8,1.6C29.8,1.6,29.8,1.6,29.8,1.6z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,1.3C29.8,1.3,29.8,1.3,29.8,1.3C29.8,1.3,29.8,1.3,29.8,1.3C29.8,1.3,29.8,1.3,29.8,1.3
    		C29.8,1.3,29.8,1.3,29.8,1.3z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,0.9C29.8,0.9,29.8,0.9,29.8,0.9C29.8,0.9,29.8,0.9,29.8,0.9C29.8,0.9,29.8,0.9,29.8,0.9
    		C29.8,0.9,29.8,0.9,29.8,0.9z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,2.8C29.8,2.8,29.8,2.8,29.8,2.8C29.8,2.8,29.8,2.8,29.8,2.8C29.8,2.7,29.8,2.7,29.8,2.8
    		C29.8,2.7,29.8,2.7,29.8,2.8z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,3.2C29.8,3.2,29.8,3.2,29.8,3.2C29.8,3.2,29.8,3.2,29.8,3.2C29.8,3.2,29.8,3.2,29.8,3.2
    		C29.8,3.2,29.8,3.2,29.8,3.2z"
            />
            <path
                fill={backgroundColor}
                d="M29.7,3.8C29.7,3.8,29.7,3.8,29.7,3.8C29.7,3.8,29.7,3.8,29.7,3.8C29.7,3.8,29.7,3.7,29.7,3.8
    		C29.7,3.8,29.7,3.8,29.7,3.8z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,2.6C29.8,2.6,29.8,2.6,29.8,2.6C29.8,2.6,29.8,2.6,29.8,2.6C29.8,2.6,29.8,2.6,29.8,2.6
    		C29.8,2.6,29.8,2.6,29.8,2.6z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,2.5C29.8,2.5,29.8,2.5,29.8,2.5C29.8,2.5,29.8,2.4,29.8,2.5C29.8,2.4,29.8,2.4,29.8,2.5
    		C29.8,2.5,29.8,2.5,29.8,2.5z"
            />
            <path
                fill={backgroundColor}
                d="M29.7,2.7C29.7,2.7,29.7,2.7,29.7,2.7C29.7,2.7,29.7,2.7,29.7,2.7C29.7,2.7,29.7,2.7,29.7,2.7
    		C29.7,2.7,29.7,2.7,29.7,2.7z"
            />
            <path
                fill={backgroundColor}
                d="M30,22.7C30,22.7,30,22.6,30,22.7c0-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2
    		c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0
    		c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
    		c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2
    		c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
    		c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0
    		c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2
    		c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0
    		c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2
    		c0,0,0,0,0,0c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1
    		c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1
    		c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0-0.4c0,0,0,0,0-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.2c0,0,0,0,0,0
    		c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1
    		c0-0.1,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2
    		c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0
    		c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1C30,5.1,30,5,30,5c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1
    		c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.2c0,0,0-0.1,0-0.1
    		c0-0.1,0-0.1,0-0.1c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
    		l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0
    		c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1C29.1,0,29.1,0,29,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0
    		c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0C26,0,26,0,26,0c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0
    		c0,0-0.1-0.1-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0,0,0-0.1,0.1c0,0-0.1,0-0.2,0c0,0,0,0,0,0.1c0,0-0.1,0-0.1-0.1
    		c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0c-0.1,0-0.1,0-0.1,0c0,0,0-0.1-0.1,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0
    		c0,0,0,0-0.1,0C19,0,19,0,19,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		C15,0,15,0,15,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0C9.2,0,9.2,0,9,0
    		c0,0,0,0,0,0C9,0,9,0,9,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C8,0,8,0,8,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0
    		c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0,0,0-0.1,0.1c0,0-0.1,0-0.2,0
    		c0,0,0,0,0,0.1c0,0-0.1,0-0.1-0.1c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0c-0.1,0-0.1,0-0.1,0
    		c0,0,0-0.1-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
    		c-0.1,0-0.1,0-0.2,0C4.6,0,4.5,0,4.5,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0
    		c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0
    		c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0.1-0.1,0-0.1,0
    		c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0
    		c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0C0.2,0,0.2,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0
    		c0,0-0.1,0-0.1,0.1l0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2
    		c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0C0,1,0,1.1,0,1.2c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1
    		c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2C0,2,0,2,0,2.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1C0,2.9,0,3,0,3.1c0,0,0,0,0,0
    		c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3C0,3.9,0.1,4,0,4c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1
    		c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1
    		c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1C0,5,0,5,0,5.1c0,0.1,0,0.3,0,0.4c0,0,0,0,0,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.1
    		C0,6,0,6,0,6.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1
    		c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1C0,7.8,0,7.9,0,8c0,0,0,0,0,0
    		c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0-0.1,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0
    		c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0C0,9,0,9.1,0,9.1c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
    		c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2
    		c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0
    		c0,0,0,0,0,0C0,11,0,11,0,11c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
    		c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0
    		c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2
    		c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0
    		c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2
    		c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1
    		c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1
    		c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0,0,0,0,0,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0,0,0,0,0
    		c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1
    		c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2
    		c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0-0.1,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0
    		c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1C0,24.9,0,25,0,25c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1
    		c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1
    		c0,0,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0,0,0.1,0,0.1
    		c0,0.1,0,0.1,0,0.1c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
    		l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
    		c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1C0.9,30,0.9,30,1,30c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0,0C4,30,4,30,4,30c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0
    		c0,0,0,0,0,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1c0,0,0.1,0,0.2,0c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0
    		c0.1,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0.1,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0
    		c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0.1,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0
    		c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1c0,0,0.1,0,0.2,0c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0
    		c0.1,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0.1,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
    		c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0-0.1,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0
    		c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0-0.1
    		c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1l-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
    		c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0
    		c0-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1
    		c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2
    		c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1
    		c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0
    		c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0-0.4c0,0,0,0,0-0.1c0-0.1,0-0.2,0-0.3
    		c0-0.1,0-0.1,0-0.1c0,0,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3
    		c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1C30,22.7,30,22.7,30,22.7z M29.9,21.6C29.9,21.6,29.9,21.6,29.9,21.6
    		C29.9,21.6,29.9,21.6,29.9,21.6z M29.9,18C29.9,18,29.9,18,29.9,18C29.9,18,29.9,18,29.9,18C29.9,18,29.9,18,29.9,18
    		C29.9,18,29.9,18,29.9,18z M29.9,16.4C29.9,16.3,29.9,16.3,29.9,16.4C29.9,16.4,29.9,16.4,29.9,16.4z M29.9,16.1
    		C29.9,16.1,29.9,16.1,29.9,16.1C29.9,16.1,29.9,16.1,29.9,16.1C29.9,16.1,29.9,16.1,29.9,16.1C29.9,16.1,29.9,16.1,29.9,16.1z
    		 M29.9,15.5C29.9,15.4,29.9,15.4,29.9,15.5C29.9,15.4,29.9,15.4,29.9,15.5z M30,17.5C29.9,17.5,29.9,17.5,30,17.5
    		C29.9,17.5,29.9,17.5,30,17.5C29.9,17.5,29.9,17.5,30,17.5C29.9,17.5,29.9,17.5,30,17.5z M29.9,15.7C29.9,15.7,29.9,15.7,29.9,15.7
    		C29.9,15.7,29.9,15.7,29.9,15.7C29.9,15.7,29.9,15.7,29.9,15.7C29.9,15.7,29.9,15.7,29.9,15.7z M29.9,8.8
    		C29.9,8.8,29.9,8.8,29.9,8.8C29.9,8.8,29.9,8.8,29.9,8.8z M29.9,6.8C29.9,6.9,29.9,6.9,29.9,6.8C29.9,6.8,29.9,6.8,29.9,6.8z
    		 M29.9,3.2C29.9,3.2,29.9,3.2,29.9,3.2C29.9,3.2,29.9,3.2,29.9,3.2C29.9,3.2,29.9,3.2,29.9,3.2C29.9,3.2,29.9,3.2,29.9,3.2z
    		 M30,2.7C29.9,2.7,29.9,2.8,30,2.7C29.9,2.8,29.9,2.7,30,2.7C29.9,2.7,29.9,2.7,30,2.7C29.9,2.7,29.9,2.7,30,2.7z M29.9,0.9
    		C29.9,0.9,29.9,0.9,29.9,0.9C29.9,1,29.9,1,29.9,0.9C29.9,1,29.9,1,29.9,0.9C29.9,0.9,29.9,0.9,29.9,0.9z M29.9,1.6
    		C29.9,1.6,29.9,1.6,29.9,1.6C29.9,1.6,29.9,1.6,29.9,1.6z M29.9,1.3C29.9,1.3,29.9,1.3,29.9,1.3C29.9,1.3,29.9,1.3,29.9,1.3
    		C29.9,1.3,29.9,1.3,29.9,1.3C29.9,1.3,29.9,1.3,29.9,1.3z M29.9,0.7C29.9,0.6,29.9,0.6,29.9,0.7C29.9,0.6,29.9,0.7,29.9,0.7z
    		 M25,0.1C25,0.1,25,0.1,25,0.1C24.9,0.1,24.9,0.1,25,0.1z M23.4,0.1C23.4,0.1,23.4,0.1,23.4,0.1C23.4,0.1,23.4,0.1,23.4,0.1z
    		 M20.6,0.2C20.6,0.2,20.6,0.2,20.6,0.2C20.6,0.2,20.6,0.2,20.6,0.2C20.6,0.2,20.6,0.2,20.6,0.2z M20.1,0.2
    		C20.1,0.2,20.1,0.2,20.1,0.2C20.1,0.2,20.1,0.2,20.1,0.2C20.1,0.2,20.1,0.2,20.1,0.2C20.1,0.2,20.1,0.2,20.1,0.2
    		C20.1,0.2,20.1,0.2,20.1,0.2z M13.5,0.1C13.5,0.1,13.5,0.1,13.5,0.1C13.5,0.1,13.5,0.1,13.5,0.1C13.5,0.1,13.5,0.1,13.5,0.1
    		C13.5,0.1,13.5,0.1,13.5,0.1z M9.2,0.2C9.2,0.2,9.2,0.2,9.2,0.2C9.2,0.2,9.1,0.2,9.2,0.2C9.1,0.2,9.2,0.2,9.2,0.2z M8.7,0.2
    		C8.7,0.2,8.7,0.2,8.7,0.2C8.7,0.2,8.7,0.2,8.7,0.2C8.7,0.2,8.7,0.2,8.7,0.2C8.7,0.2,8.7,0.2,8.7,0.2C8.7,0.2,8.7,0.2,8.7,0.2z
    		 M6.8,0.1C6.8,0.1,6.8,0.1,6.8,0.1C6.7,0.1,6.7,0.1,6.8,0.1C6.7,0.1,6.8,0.1,6.8,0.1z M5.2,0.1C5.3,0.1,5.3,0.1,5.2,0.1
    		C5.2,0.1,5.2,0.1,5.2,0.1z M2.4,0.1C2.4,0.1,2.4,0.1,2.4,0.1C2.4,0.2,2.4,0.2,2.4,0.1C2.4,0.2,2.4,0.2,2.4,0.1
    		C2.4,0.1,2.4,0.1,2.4,0.1z M2.1,0.1C2.1,0.1,2.1,0.1,2.1,0.1C2.1,0.1,2.1,0.1,2.1,0.1C2.1,0.1,2.1,0.1,2.1,0.1
    		C2.1,0.1,2.1,0.1,2.1,0.1z M2,0.1C2,0.2,2,0.2,2,0.1C2,0.2,2,0.2,2,0.1C1.9,0.2,1.9,0.2,2,0.1C1.9,0.2,1.9,0.2,2,0.1z M1.2,0.1
    		C1.2,0.1,1.2,0.1,1.2,0.1C1.2,0.1,1.2,0.1,1.2,0.1z M1,0.1C1,0.1,1,0.1,1,0.1C1,0.1,1,0.1,1,0.1C0.9,0.1,0.9,0.1,1,0.1
    		C1,0.1,1,0.1,1,0.1z M0.7,0.1C0.7,0.1,0.7,0.1,0.7,0.1C0.7,0.1,0.7,0.1,0.7,0.1C0.7,0.1,0.7,0.1,0.7,0.1C0.7,0.1,0.7,0.1,0.7,0.1z
    		 M0.4,0.1C0.4,0.1,0.5,0.1,0.4,0.1C0.4,0.2,0.4,0.1,0.4,0.1z M0.1,6.4C0.1,6.4,0.1,6.4,0.1,6.4C0.1,6.4,0.1,6.4,0.1,6.4z M0.1,8.4
    		C0.1,8.4,0.1,8.4,0.1,8.4C0.1,8.4,0.1,8.4,0.1,8.4z M0.1,12C0.1,12,0.1,12,0.1,12C0.1,12,0.1,12,0.1,12C0.1,12,0.1,12,0.1,12
    		C0.1,12,0.1,12,0.1,12z M0.1,13.6C0.1,13.7,0.1,13.7,0.1,13.6C0.1,13.6,0.1,13.6,0.1,13.6z M0.1,13.9C0.1,13.9,0.1,13.9,0.1,13.9
    		C0.1,13.9,0.1,13.9,0.1,13.9C0.1,13.9,0.1,13.9,0.1,13.9C0.1,13.9,0.1,13.9,0.1,13.9z M0.1,14.5C0.1,14.6,0.1,14.6,0.1,14.5
    		C0.1,14.6,0.1,14.6,0.1,14.5z M0,12.5C0.1,12.5,0.1,12.5,0,12.5C0.1,12.5,0.1,12.5,0,12.5C0.1,12.5,0.1,12.5,0,12.5
    		C0.1,12.5,0.1,12.5,0,12.5z M0.1,14.3C0.1,14.3,0.1,14.3,0.1,14.3C0.1,14.3,0.1,14.3,0.1,14.3C0.1,14.3,0.1,14.3,0.1,14.3
    		C0.1,14.3,0.1,14.3,0.1,14.3z M0.1,21.2C0.1,21.2,0.1,21.2,0.1,21.2C0.1,21.2,0.1,21.2,0.1,21.2z M0.1,23.2
    		C0.1,23.1,0.1,23.1,0.1,23.2C0.1,23.2,0.1,23.2,0.1,23.2z M0.1,26.8C0.1,26.8,0.1,26.8,0.1,26.8C0.1,26.8,0.1,26.8,0.1,26.8
    		C0.1,26.8,0.1,26.8,0.1,26.8C0.1,26.8,0.1,26.8,0.1,26.8z M0,27.3C0.1,27.3,0.1,27.2,0,27.3C0.1,27.2,0.1,27.3,0,27.3
    		C0.1,27.3,0.1,27.3,0,27.3C0.1,27.3,0.1,27.3,0,27.3z M0.1,29.1C0.1,29.1,0.1,29.1,0.1,29.1C0.1,29,0.1,29,0.1,29.1
    		C0.1,29,0.1,29,0.1,29.1C0.1,29.1,0.1,29.1,0.1,29.1z M0.1,28.4C0.1,28.4,0.1,28.4,0.1,28.4C0.1,28.4,0.1,28.4,0.1,28.4z M0.1,28.7
    		C0.1,28.7,0.1,28.7,0.1,28.7C0.1,28.7,0.1,28.7,0.1,28.7C0.1,28.7,0.1,28.7,0.1,28.7C0.1,28.7,0.1,28.7,0.1,28.7z M0.1,29.4
    		C0.1,29.4,0.1,29.3,0.1,29.4C0.1,29.4,0.1,29.4,0.1,29.4z M5,29.9C5,29.9,5,29.9,5,29.9C5.1,29.9,5.1,29.9,5,29.9z M6.6,29.9
    		C6.6,29.9,6.6,29.9,6.6,29.9C6.6,29.9,6.6,29.9,6.6,29.9z M9.4,29.8C9.4,29.8,9.4,29.8,9.4,29.8C9.4,29.8,9.4,29.8,9.4,29.8
    		C9.4,29.8,9.4,29.8,9.4,29.8z M9.9,29.8C9.9,29.8,9.9,29.8,9.9,29.8C9.9,29.8,9.9,29.8,9.9,29.8C9.9,29.8,9.9,29.8,9.9,29.8
    		C9.9,29.8,9.9,29.8,9.9,29.8C9.9,29.8,9.9,29.8,9.9,29.8z M16.5,29.9C16.5,29.9,16.5,29.9,16.5,29.9C16.5,29.9,16.5,29.9,16.5,29.9
    		C16.5,29.9,16.5,29.9,16.5,29.9C16.5,29.9,16.5,29.9,16.5,29.9z M20.8,29.8C20.8,29.8,20.8,29.8,20.8,29.8
    		C20.8,29.8,20.9,29.8,20.8,29.8C20.9,29.8,20.8,29.8,20.8,29.8z M21.3,29.8C21.3,29.8,21.3,29.8,21.3,29.8
    		C21.3,29.8,21.3,29.8,21.3,29.8C21.3,29.8,21.3,29.8,21.3,29.8C21.3,29.8,21.3,29.8,21.3,29.8C21.3,29.8,21.3,29.8,21.3,29.8z
    		 M23.2,29.9C23.2,29.9,23.2,29.9,23.2,29.9C23.3,29.9,23.3,29.9,23.2,29.9C23.3,29.9,23.2,29.9,23.2,29.9z M24.8,29.9
    		C24.7,29.9,24.7,29.9,24.8,29.9C24.8,29.9,24.8,29.9,24.8,29.9z M27.6,29.9C27.6,29.9,27.6,29.9,27.6,29.9
    		C27.6,29.8,27.6,29.8,27.6,29.9C27.6,29.8,27.6,29.8,27.6,29.9C27.6,29.9,27.6,29.9,27.6,29.9z M27.9,29.9
    		C27.9,29.9,27.9,29.9,27.9,29.9C27.9,29.9,27.9,29.9,27.9,29.9C27.9,29.9,27.9,29.9,27.9,29.9C27.9,29.9,27.9,29.9,27.9,29.9z
    		 M28,29.9C28,29.8,28,29.8,28,29.9C28,29.8,28,29.8,28,29.9C28.1,29.8,28.1,29.8,28,29.9C28.1,29.8,28.1,29.8,28,29.9z M28.8,29.9
    		C28.8,29.9,28.8,29.9,28.8,29.9C28.8,29.9,28.8,29.9,28.8,29.9z M29,29.9C29,29.9,29,29.9,29,29.9C29,29.9,29,29.9,29,29.9
    		C29.1,29.9,29.1,29.9,29,29.9C29,29.9,29,29.9,29,29.9z M29.3,29.9C29.3,29.9,29.3,29.9,29.3,29.9C29.3,29.9,29.3,29.9,29.3,29.9
    		C29.3,29.9,29.3,29.9,29.3,29.9C29.3,29.9,29.3,29.9,29.3,29.9z M29.6,29.9C29.6,29.9,29.5,29.9,29.6,29.9
    		C29.6,29.8,29.6,29.9,29.6,29.9z M0.1,27.4C0.1,27.4,0.1,27.4,0.1,27.4C0.1,27.4,0.1,27.4,0.1,27.4C0.1,27.4,0.1,27.4,0.1,27.4
    		C0.1,27.4,0.1,27.4,0.1,27.4z M0.1,12.6C0.1,12.6,0.1,12.6,0.1,12.6C0.1,12.6,0.1,12.6,0.1,12.6C0.1,12.6,0.1,12.6,0.1,12.6
    		C0.1,12.6,0.1,12.6,0.1,12.6z M29.9,2.6C29.9,2.6,29.9,2.6,29.9,2.6C29.9,2.6,29.9,2.6,29.9,2.6C29.9,2.6,29.9,2.6,29.9,2.6
    		C29.9,2.6,29.9,2.6,29.9,2.6z M29.9,17.4C29.9,17.4,29.9,17.4,29.9,17.4C29.9,17.4,29.9,17.4,29.9,17.4
    		C29.9,17.4,29.9,17.4,29.9,17.4C29.9,17.4,29.9,17.4,29.9,17.4z M29.9,23.6C29.9,23.6,29.9,23.6,29.9,23.6
    		C29.9,23.6,29.9,23.6,29.9,23.6z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,21.8C29.8,21.8,29.8,21.8,29.8,21.8C29.8,21.8,29.8,21.8,29.8,21.8z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,23.8C29.8,23.8,29.8,23.8,29.8,23.8C29.8,23.8,29.8,23.8,29.8,23.8z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,16.5C29.8,16.5,29.8,16.5,29.8,16.5C29.8,16.5,29.8,16.5,29.8,16.5C29.8,16.5,29.8,16.5,29.8,16.5
    		C29.8,16.5,29.8,16.5,29.8,16.5z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,16.3C29.8,16.3,29.8,16.4,29.8,16.3C29.8,16.3,29.8,16.3,29.8,16.3z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,16C29.8,16,29.8,16,29.8,16C29.8,16,29.8,16.1,29.8,16C29.8,16.1,29.8,16.1,29.8,16
    		C29.8,16.1,29.8,16,29.8,16z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,15.7C29.8,15.7,29.8,15.7,29.8,15.7C29.8,15.7,29.8,15.7,29.8,15.7C29.8,15.7,29.8,15.7,29.8,15.7
    		C29.8,15.7,29.8,15.7,29.8,15.7z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,17.5C29.8,17.5,29.8,17.6,29.8,17.5C29.8,17.6,29.8,17.5,29.8,17.5C29.8,17.5,29.8,17.5,29.8,17.5
    		C29.8,17.5,29.8,17.5,29.8,17.5z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,18C29.8,18,29.8,18,29.8,18C29.8,18,29.8,18,29.8,18C29.8,18,29.8,18,29.8,18C29.8,18,29.8,18,29.8,18z"
            />
            <path
                fill={backgroundColor}
                d="M29.7,18.6C29.7,18.6,29.7,18.6,29.7,18.6C29.7,18.6,29.7,18.6,29.7,18.6C29.7,18.5,29.7,18.5,29.7,18.6
    		C29.7,18.5,29.7,18.5,29.7,18.6z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,17.4C29.8,17.4,29.8,17.4,29.8,17.4C29.8,17.4,29.8,17.4,29.8,17.4C29.8,17.4,29.8,17.4,29.8,17.4
    		C29.8,17.4,29.8,17.4,29.8,17.4z"
            />
            <path
                fill={backgroundColor}
                d="M29.8,17.2C29.8,17.2,29.8,17.3,29.8,17.2C29.8,17.3,29.8,17.2,29.8,17.2C29.8,17.2,29.8,17.2,29.8,17.2
    		C29.8,17.2,29.8,17.2,29.8,17.2z"
            />
            <path
                fill={backgroundColor}
                d="M29.7,17.5C29.7,17.5,29.7,17.5,29.7,17.5C29.7,17.5,29.7,17.5,29.7,17.5C29.7,17.5,29.7,17.5,29.7,17.5
    		C29.7,17.5,29.7,17.5,29.7,17.5z"
            />
            <path
                fill={backgroundColor}
                d="M24.6,29.7C24.6,29.7,24.6,29.8,24.6,29.7C24.6,29.7,24.6,29.7,24.6,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M23,29.8C23.1,29.8,23.1,29.8,23,29.8C23,29.7,23,29.8,23,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M28.7,29.7C28.7,29.7,28.7,29.7,28.7,29.7C28.7,29.7,28.8,29.7,28.7,29.7C28.8,29.7,28.8,29.7,28.7,29.7
    		C28.7,29.7,28.7,29.7,28.7,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M28.8,29.8C28.9,29.8,28.9,29.8,28.8,29.8C28.8,29.8,28.8,29.8,28.8,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M29.1,29.7C29.1,29.7,29.1,29.7,29.1,29.7C29.1,29.8,29.1,29.8,29.1,29.7C29.1,29.7,29.1,29.7,29.1,29.7
    		C29.1,29.7,29.1,29.7,29.1,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M29.3,29.8C29.3,29.8,29.3,29.8,29.3,29.8C29.4,29.8,29.4,29.8,29.3,29.8C29.4,29.8,29.4,29.8,29.3,29.8
    		C29.3,29.8,29.3,29.8,29.3,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M27.9,29.8C27.9,29.8,27.9,29.8,27.9,29.8C27.9,29.8,27.9,29.8,27.9,29.8C27.9,29.8,27.9,29.8,27.9,29.8
    		C27.9,29.8,27.9,29.8,27.9,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M27.6,29.7C27.5,29.7,27.5,29.7,27.6,29.7C27.5,29.7,27.5,29.7,27.6,29.7C27.6,29.7,27.6,29.7,27.6,29.7
    		C27.6,29.7,27.6,29.7,27.6,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M27.1,29.6C27.1,29.6,27.1,29.6,27.1,29.6C27.1,29.6,27.1,29.6,27.1,29.6C27.1,29.6,27.2,29.6,27.1,29.6
    		C27.1,29.6,27.1,29.6,27.1,29.6z"
            />
            <path
                fill={backgroundColor}
                d="M28,29.7C28,29.7,28,29.7,28,29.7C28,29.7,28.1,29.7,28,29.7C28.1,29.7,28,29.7,28,29.7
    		C28,29.7,28,29.7,28,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M28.1,29.7C28.1,29.7,28.1,29.7,28.1,29.7C28.1,29.7,28.1,29.7,28.1,29.7C28.2,29.7,28.2,29.7,28.1,29.7
    		C28.2,29.7,28.2,29.7,28.1,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M27.9,29.6C27.9,29.6,27.9,29.6,27.9,29.6C28,29.6,28,29.6,27.9,29.6C28,29.6,28,29.6,27.9,29.6
    		C27.9,29.6,27.9,29.6,27.9,29.6z"
            />
            <path
                fill={backgroundColor}
                d="M13.1,29.7C13.2,29.7,13.2,29.8,13.1,29.7C13.2,29.7,13.2,29.7,13.1,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M11.6,29.8C11.6,29.8,11.6,29.8,11.6,29.8C11.6,29.7,11.6,29.8,11.6,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M17.3,29.7C17.3,29.7,17.3,29.7,17.3,29.7C17.3,29.7,17.3,29.7,17.3,29.7C17.3,29.7,17.3,29.7,17.3,29.7
    		C17.3,29.7,17.3,29.7,17.3,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M17.4,29.8C17.4,29.8,17.4,29.8,17.4,29.8C17.4,29.8,17.4,29.8,17.4,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M17.6,29.7C17.6,29.7,17.6,29.7,17.6,29.7C17.6,29.8,17.6,29.8,17.6,29.7C17.6,29.7,17.6,29.7,17.6,29.7
    		C17.6,29.7,17.6,29.7,17.6,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M16.5,29.8C16.5,29.8,16.5,29.8,16.5,29.8C16.5,29.8,16.5,29.8,16.5,29.8C16.5,29.8,16.5,29.8,16.5,29.8
    		C16.5,29.8,16.5,29.8,16.5,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M16.1,29.7C16.1,29.7,16.1,29.7,16.1,29.7C16.1,29.7,16.1,29.7,16.1,29.7C16.1,29.7,16.1,29.7,16.1,29.7
    		C16.1,29.7,16.1,29.7,16.1,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M15.7,29.6C15.7,29.6,15.7,29.6,15.7,29.6C15.7,29.6,15.7,29.6,15.7,29.6C15.7,29.6,15.7,29.6,15.7,29.6
    		C15.7,29.6,15.7,29.6,15.7,29.6z"
            />
            <path
                fill={backgroundColor}
                d="M16.6,29.7C16.6,29.7,16.6,29.7,16.6,29.7C16.6,29.7,16.6,29.7,16.6,29.7C16.6,29.7,16.6,29.7,16.6,29.7
    		C16.6,29.7,16.6,29.7,16.6,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M16.7,29.7C16.7,29.7,16.7,29.7,16.7,29.7C16.7,29.7,16.7,29.7,16.7,29.7C16.7,29.7,16.7,29.7,16.7,29.7
    		C16.7,29.7,16.7,29.7,16.7,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M16.5,29.6C16.5,29.6,16.5,29.6,16.5,29.6C16.5,29.6,16.5,29.6,16.5,29.6C16.5,29.6,16.5,29.6,16.5,29.6
    		C16.5,29.6,16.5,29.6,16.5,29.6z"
            />
            <path
                fill={backgroundColor}
                d="M17.9,29.7C17.9,29.7,17.9,29.8,17.9,29.7C17.9,29.7,17.9,29.7,17.9,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M16.3,29.8C16.3,29.8,16.3,29.8,16.3,29.8C16.3,29.7,16.3,29.8,16.3,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M22,29.7C22,29.7,22,29.7,22,29.7C22,29.7,22,29.7,22,29.7C22,29.7,22,29.7,22,29.7C22,29.7,22,29.7,22,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M22.1,29.8C22.1,29.8,22.1,29.8,22.1,29.8C22.1,29.8,22.1,29.8,22.1,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M22.3,29.7C22.3,29.7,22.3,29.7,22.3,29.7C22.3,29.8,22.3,29.8,22.3,29.7C22.4,29.7,22.4,29.7,22.3,29.7
    		C22.3,29.7,22.3,29.7,22.3,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M22.6,29.8C22.6,29.8,22.6,29.8,22.6,29.8C22.6,29.8,22.6,29.8,22.6,29.8C22.6,29.8,22.6,29.8,22.6,29.8
    		C22.6,29.8,22.6,29.8,22.6,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M21.2,29.8C21.2,29.8,21.2,29.8,21.2,29.8C21.2,29.8,21.2,29.8,21.2,29.8C21.2,29.8,21.2,29.8,21.2,29.8
    		C21.2,29.8,21.2,29.8,21.2,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M20.8,29.7C20.8,29.7,20.8,29.7,20.8,29.7C20.8,29.7,20.8,29.7,20.8,29.7C20.8,29.7,20.8,29.7,20.8,29.7
    		C20.8,29.7,20.8,29.7,20.8,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M20.4,29.6C20.4,29.6,20.4,29.6,20.4,29.6C20.4,29.6,20.4,29.6,20.4,29.6C20.4,29.6,20.4,29.6,20.4,29.6
    		C20.4,29.6,20.4,29.6,20.4,29.6z"
            />
            <path
                fill={backgroundColor}
                d="M21.3,29.7C21.3,29.7,21.3,29.7,21.3,29.7C21.3,29.7,21.3,29.7,21.3,29.7C21.3,29.7,21.3,29.7,21.3,29.7
    		C21.3,29.7,21.3,29.7,21.3,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M21.4,29.7C21.4,29.7,21.4,29.7,21.4,29.7C21.4,29.7,21.4,29.7,21.4,29.7C21.4,29.7,21.4,29.7,21.4,29.7
    		C21.4,29.7,21.4,29.7,21.4,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M21.2,29.6C21.2,29.6,21.2,29.6,21.2,29.6C21.2,29.6,21.2,29.6,21.2,29.6C21.2,29.6,21.2,29.6,21.2,29.6
    		C21.2,29.6,21.2,29.6,21.2,29.6z"
            />
            <path
                fill={backgroundColor}
                d="M6.4,29.7C6.4,29.7,6.4,29.8,6.4,29.7C6.5,29.7,6.5,29.7,6.4,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M4.8,29.8C4.9,29.8,4.9,29.8,4.8,29.8C4.9,29.7,4.9,29.8,4.8,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M10.6,29.7C10.6,29.7,10.6,29.7,10.6,29.7C10.6,29.7,10.6,29.7,10.6,29.7C10.6,29.7,10.6,29.7,10.6,29.7
    		C10.6,29.7,10.6,29.7,10.6,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M10.6,29.8C10.7,29.8,10.7,29.8,10.6,29.8C10.7,29.8,10.7,29.8,10.6,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M10.9,29.7C10.9,29.7,10.9,29.7,10.9,29.7C10.9,29.8,10.9,29.8,10.9,29.7C10.9,29.7,10.9,29.7,10.9,29.7
    		C10.9,29.7,10.9,29.7,10.9,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M11.2,29.8C11.2,29.8,11.2,29.8,11.2,29.8C11.2,29.8,11.2,29.8,11.2,29.8C11.2,29.8,11.2,29.8,11.2,29.8
    		C11.2,29.8,11.2,29.8,11.2,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M9.7,29.8C9.7,29.8,9.7,29.8,9.7,29.8C9.8,29.8,9.8,29.8,9.7,29.8C9.8,29.8,9.7,29.8,9.7,29.8
    		C9.7,29.8,9.7,29.8,9.7,29.8z"
            />
            <path
                fill={backgroundColor}
                d="M9.4,29.7C9.4,29.7,9.4,29.7,9.4,29.7C9.4,29.7,9.4,29.7,9.4,29.7C9.4,29.7,9.4,29.7,9.4,29.7
    		C9.4,29.7,9.4,29.7,9.4,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M9,29.6C8.9,29.6,8.9,29.6,9,29.6C8.9,29.6,8.9,29.6,9,29.6C9,29.6,9,29.6,9,29.6C9,29.6,9,29.6,9,29.6z"
            />
            <path
                fill={backgroundColor}
                d="M9.8,29.7C9.8,29.7,9.9,29.7,9.8,29.7C9.9,29.7,9.9,29.7,9.8,29.7C9.9,29.7,9.9,29.7,9.8,29.7
    		C9.9,29.7,9.9,29.7,9.8,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M10,29.7C10,29.7,10,29.7,10,29.7C10,29.7,10,29.7,10,29.7C10,29.7,10,29.7,10,29.7C10,29.7,10,29.7,10,29.7z"
            />
            <path
                fill={backgroundColor}
                d="M9.7,29.6C9.8,29.6,9.8,29.6,9.7,29.6C9.8,29.6,9.8,29.6,9.7,29.6C9.8,29.6,9.8,29.6,9.7,29.6
    		C9.8,29.6,9.8,29.6,9.7,29.6z"
            />
            <path fill={backgroundColor} d="M0.2,23C0.2,23,0.2,23,0.2,23C0.2,23,0.2,23,0.2,23z" />
            <path
                fill={backgroundColor}
                d="M0.2,20.9C0.2,21,0.2,21,0.2,20.9C0.2,20.9,0.2,20.9,0.2,20.9z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,28.3C0.2,28.3,0.2,28.3,0.2,28.3C0.2,28.3,0.2,28.3,0.2,28.3C0.2,28.3,0.2,28.3,0.2,28.3
    		C0.2,28.3,0.2,28.3,0.2,28.3z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,28.4C0.2,28.5,0.2,28.5,0.2,28.4C0.2,28.4,0.2,28.4,0.2,28.4z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,28.7C0.2,28.7,0.2,28.7,0.2,28.7C0.2,28.7,0.2,28.7,0.2,28.7C0.2,28.7,0.2,28.7,0.2,28.7
    		C0.2,28.7,0.2,28.7,0.2,28.7z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,29.1C0.2,29.1,0.2,29.1,0.2,29.1C0.2,29.1,0.2,29.1,0.2,29.1C0.2,29.1,0.2,29.1,0.2,29.1
    		C0.2,29.1,0.2,29.1,0.2,29.1z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,27.2C0.2,27.2,0.2,27.2,0.2,27.2C0.2,27.2,0.2,27.2,0.2,27.2C0.2,27.3,0.2,27.3,0.2,27.2
    		C0.2,27.3,0.2,27.3,0.2,27.2z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,26.8C0.2,26.8,0.2,26.8,0.2,26.8C0.2,26.8,0.2,26.8,0.2,26.8C0.2,26.8,0.2,26.8,0.2,26.8
    		C0.2,26.8,0.2,26.8,0.2,26.8z"
            />
            <path
                fill={backgroundColor}
                d="M0.3,26.2C0.3,26.2,0.3,26.2,0.3,26.2C0.3,26.2,0.3,26.2,0.3,26.2C0.3,26.2,0.3,26.3,0.3,26.2
    		C0.3,26.2,0.3,26.2,0.3,26.2z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,27.4C0.2,27.4,0.2,27.4,0.2,27.4C0.2,27.4,0.2,27.4,0.2,27.4C0.2,27.4,0.2,27.4,0.2,27.4
    		C0.2,27.4,0.2,27.4,0.2,27.4z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,27.5C0.2,27.5,0.2,27.5,0.2,27.5C0.2,27.5,0.2,27.6,0.2,27.5C0.2,27.6,0.2,27.6,0.2,27.5
    		C0.2,27.5,0.2,27.5,0.2,27.5z"
            />
            <path
                fill={backgroundColor}
                d="M0.3,27.3C0.3,27.3,0.3,27.3,0.3,27.3C0.3,27.3,0.3,27.3,0.3,27.3C0.3,27.3,0.3,27.3,0.3,27.3
    		C0.3,27.3,0.3,27.3,0.3,27.3z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,8.2C0.2,8.2,0.2,8.2,0.2,8.2C0.2,8.2,0.2,8.2,0.2,8.2z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,6.1C0.2,6.2,0.2,6.2,0.2,6.1C0.2,6.2,0.2,6.2,0.2,6.1z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,13.5C0.2,13.5,0.2,13.5,0.2,13.5C0.2,13.5,0.2,13.5,0.2,13.5C0.2,13.5,0.2,13.5,0.2,13.5
    		C0.2,13.5,0.2,13.5,0.2,13.5z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,13.7C0.2,13.7,0.2,13.6,0.2,13.7C0.2,13.7,0.2,13.7,0.2,13.7z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,14C0.2,14,0.2,14,0.2,14C0.2,14,0.2,13.9,0.2,14C0.2,13.9,0.2,13.9,0.2,14C0.2,13.9,0.2,14,0.2,14z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,14.3C0.2,14.3,0.2,14.3,0.2,14.3C0.2,14.3,0.2,14.3,0.2,14.3C0.2,14.3,0.2,14.3,0.2,14.3
    		C0.2,14.3,0.2,14.3,0.2,14.3z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,12.5C0.2,12.5,0.2,12.4,0.2,12.5C0.2,12.4,0.2,12.5,0.2,12.5C0.2,12.5,0.2,12.5,0.2,12.5
    		C0.2,12.5,0.2,12.5,0.2,12.5z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,12C0.2,12,0.2,12,0.2,12C0.2,12,0.2,12,0.2,12C0.2,12,0.2,12,0.2,12C0.2,12,0.2,12,0.2,12z"
            />
            <path
                fill={backgroundColor}
                d="M0.3,11.4C0.3,11.4,0.3,11.4,0.3,11.4C0.3,11.4,0.3,11.4,0.3,11.4C0.3,11.5,0.3,11.5,0.3,11.4
    		C0.3,11.5,0.3,11.5,0.3,11.4z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,12.6C0.2,12.6,0.2,12.6,0.2,12.6C0.2,12.6,0.2,12.6,0.2,12.6C0.2,12.6,0.2,12.6,0.2,12.6
    		C0.2,12.6,0.2,12.6,0.2,12.6z"
            />
            <path
                fill={backgroundColor}
                d="M0.2,12.7C0.2,12.7,0.2,12.8,0.2,12.7C0.2,12.8,0.2,12.8,0.2,12.7C0.2,12.8,0.2,12.8,0.2,12.7
    		C0.2,12.8,0.2,12.7,0.2,12.7z"
            />
            <path
                fill={backgroundColor}
                d="M0.3,12.5C0.3,12.5,0.3,12.5,0.3,12.5C0.3,12.5,0.3,12.5,0.3,12.5C0.3,12.5,0.3,12.5,0.3,12.5
    		C0.3,12.5,0.3,12.5,0.3,12.5z"
            />
        </g>
        <g className={classNames([{ [styles.left]: isLeft }])}>
            <path
                fill={color}
                d="M6.3,24.8c0,0.1,0,0.1,0,0.2C6.3,24.9,6.3,24.9,6.3,24.8C6.3,24.9,6.4,25,6.4,25c0.1-0.2,0.2-0.1,0.2-0.1
    		c0,0,0.1,0,0.1-0.2c0,0.2,0,0.4,0,0.6C6.9,24.8,7,24.8,7.1,25c0-0.1,0-0.2,0.1-0.3c0,0.1,0,0.1,0.1,0.2c0,0,0,0.1,0.1,0.2
    		c0-0.1,0-0.2,0-0.2c0.1,0.1,0.1,0.2,0.2,0.1c0.1-0.2,0.2,0,0.2,0c0.1,0,0.2,0.2,0.2-0.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1
    		c0,0.2,0.1,0.3,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.1,0.2c0-0.1,0.1-0.2,0.1-0.3c0,0.1,0,0.2,0.1,0.4
    		c0-0.2,0-0.3,0-0.4c0,0,0.1,0,0.1,0.3c0,0,0.1,0,0.1,0c0,0,0,0.1,0.1,0C8.9,24.9,9,24.8,9,25c0,0,0,0,0,0c0-0.2,0.1,0,0.1-0.1
    		c0,0,0-0.1,0.1-0.2c0.1,0.2,0.1,0.2,0.2,0c0,0.1,0,0.2,0,0.3c0.1-0.1,0.2-0.3,0.3-0.1c0.1-0.2,0.2,0.2,0.2-0.1c0,0,0,0-0.1,0
    		c0-0.1,0-0.3,0-0.4c0,0.1,0.1,0.2,0,0.4c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
    		c0-0.1,0-0.2,0.1-0.3c0,0.1,0,0.2,0,0.2c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.2-0.1c0-0.1,0-0.1,0.1-0.1c0,0.1,0,0.2,0,0.4
    		c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0,0,0c0,0.1,0.1,0.2,0.1,0.3c0-0.1,0-0.2,0-0.2c0,0,0.1,0.1,0.1,0.1c0,0,0-0.2,0.1-0.2
    		c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.3,0,0.4-0.2c0,0,0,0,0.1,0c0.1,0.4,0.2,0,0.3,0.1c0.1-0.4,0.1,0,0.1,0.2c0.1-0.3,0.1-0.4,0.2-0.2
    		c0,0,0,0.1,0,0c0.1-0.1,0.1,0.1,0.2,0.3c0-0.1,0-0.3,0-0.3c0.1,0.1,0.2,0,0.2,0c0.1,0,0.2,0.2,0.3,0.1c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.1,0c0.1,0.4,0.1,0.1,0.1,0c0.1,0.2,0.1,0.2,0.1-0.2c0,0.2,0,0.3,0.1,0.5
    		c0.1-0.4,0.2,0.1,0.2-0.3c0,0.2,0,0.3,0,0.4c0-0.2,0.1-0.3,0.1-0.5c0.1,0.3,0.2,0,0.2,0.1c0,0.1,0,0.1,0,0.2c0.1,0.1,0.1,0,0.2-0.3
    		c0,0.1,0.1,0.4,0.1,0.2c0.1-0.2,0.1,0.1,0.1,0.3c0-0.1,0.1-0.4,0.1-0.3c0-0.1,0-0.2,0-0.3c0,0.2,0,0.3,0,0.4c0,0,0,0,0,0
    		c0-0.1,0-0.3,0.1-0.4c0,0.1,0.1,0.2,0.1,0.2c0-0.1,0-0.2,0-0.2c0,0.1,0.1,0.2,0.1,0.3c0-0.1,0-0.2,0-0.3c0,0.1,0,0.2,0.1,0.4
    		c0-0.1,0-0.3,0-0.4c0.1,0.3,0.1,0.4,0.2,0.2c0.1-0.2,0.2-0.1,0.3,0c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1,0.3,0.1,0.1c0-0.1,0-0.2,0.1-0.3
    		c0,0.1,0.1,0.3,0.1,0.4c0-0.1,0.1-0.2,0.1-0.3c0,0.1,0,0.2,0,0.3c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1-0.1,0.1-0.3,0.2,0.1
    		c0.1-0.2,0.1,0.1,0.2-0.2c0-0.1,0.1-0.1,0.1,0c0,0.2,0,0.2,0.1,0.2c0,0,0,0.1,0,0.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1
    		c0,0,0,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1,0.1,0.1,0.4c0,0,0,0,0,0.1c0-0.2,0-0.3,0-0.5c0,0,0.1,0.1,0.1,0.1
    		c0,0,0.1,0.1,0.1,0c0-0.1,0-0.2,0-0.4c0,0.1,0.1,0.3,0.1,0.4c0,0,0.1,0,0.1-0.1c0.1-0.2,0.1-0.2,0.2,0.2c0-0.3,0.1-0.3,0.1-0.2
    		c0,0.1,0.1,0.1,0.1,0c0.1,0,0.1-0.1,0.2,0c0,0.1,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0.1,0.2c0.1,0.2,0.2-0.3,0.3-0.3c0,0.1,0,0.2,0,0.3
    		c0.1,0.1,0.1-0.1,0.2-0.4c0,0.2,0.1,0.2,0.1,0.1c0,0,0,0,0,0c0,0.3,0.1,0.1,0.1,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1
    		c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0.3,0.1,0.1,0.1,0.2c0,0.3,0.1-0.1,0.1-0.1c0,0.1,0.1,0.2,0.1,0c0-0.1,0.1,0,0.1,0
    		c0.1,0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.2,0,0.3c0-0.1,0-0.1,0.1-0.2c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0
    		c0,0,0,0,0-0.1c0,0.4,0.1,0.4,0.2,0.2c0-0.1,0.1-0.1,0.1-0.1c0,0.1,0,0.2,0,0.4c0.1,0,0.1,0,0.1-0.1c0.1-0.3,0.1-0.2,0.2,0
    		c0.1,0.1,0.1,0.2,0.2,0.1c0,0,0.1-0.2,0.1-0.3c0.1,0.3,0.1,0.4,0.1,0.3c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0.1,0,0.1,0c0,0.1,0.1,0,0.1-0.2c0,0,0-0.1,0-0.1c0,0.1,0,0.2,0,0.3c0.1-0.1,0.2-0.1,0.2-0.1l0.1-0.3c0-0.2,0-0.3-0.1-0.4
    		c0-0.1-0.1-0.2-0.1-0.4c-0.1,0-0.1,0.1-0.2,0.1c0-0.1,0-0.2,0-0.3c0,0,0,0.1,0,0.1c0,0.2,0,0.3-0.1,0.2c-0.1-0.1-0.2-0.1-0.3,0.1
    		c0,0.1-0.1,0-0.1-0.3c0,0.1-0.1,0.3-0.1,0.3c-0.1,0-0.1,0-0.2-0.1c-0.1-0.2-0.1-0.3-0.1,0c0,0.1-0.1,0.1-0.1,0.1c0-0.1,0-0.2,0-0.4
    		c0,0.1-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.2-0.2-0.2c0,0.1-0.1,0.2-0.1,0.3c0-0.1,0-0.2,0-0.3c-0.1,0.1-0.1,0.3-0.2,0.2
    		c0-0.1-0.1-0.1-0.1,0c0,0.2-0.1,0.1-0.1,0c0-0.1-0.1,0.3-0.1,0.1c0,0-0.1,0.1-0.1-0.2c0,0-0.1,0-0.1,0c0,0.1-0.1,0.3-0.1,0
    		c0,0,0,0,0,0c-0.1,0-0.1,0-0.1-0.1c0,0.3-0.1,0.5-0.1,0.4c0-0.1,0-0.2,0-0.3c-0.1,0-0.2,0.5-0.3,0.3c0-0.2,0-0.3-0.1-0.2
    		c0,0.1-0.1,0.1-0.1,0.1c-0.1-0.1-0.1-0.1-0.2,0c0,0-0.1,0.1-0.1,0c0-0.1-0.1-0.1-0.1,0.2C18,23.8,18,23.8,17.9,24
    		c0,0.1-0.1,0.1-0.1,0.1c0-0.1-0.1-0.3-0.1-0.4c0,0.2,0,0.3,0,0.4c0,0,0,0-0.1,0c0,0,0-0.1-0.1-0.1c0,0.2,0,0.4,0,0.5c0,0,0,0,0-0.1
    		c0-0.3-0.1-0.5-0.1-0.4c0,0-0.1,0.1-0.1,0.1c0,0,0-0.1-0.1-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0-0.1,0-0.2,0-0.2c0,0,0,0-0.1-0.2
    		c0-0.2,0-0.2-0.1,0c-0.1,0.3-0.1,0-0.2,0.2c0-0.3-0.1-0.2-0.1-0.1c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.3
    		c0,0.1-0.1,0.2-0.1,0.3c0-0.1-0.1-0.2-0.1-0.4c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1-0.3-0.1-0.1c0,0.1-0.1,0.1-0.1,0.1
    		c-0.1-0.1-0.2-0.2-0.3,0c-0.1,0.1-0.1,0.1-0.2-0.2c0,0.1,0,0.2,0,0.4c0-0.2-0.1-0.3-0.1-0.4c0,0.1,0,0.2,0,0.3
    		c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0.1,0,0.2c0-0.1-0.1-0.1-0.1-0.2c0,0.1,0,0.2-0.1,0.4c-0.1-0.4-0.1,0-0.1,0.1c0-0.2,0-0.5-0.1-0.3
    		c-0.1,0.2-0.1-0.2-0.1-0.2c0,0.3-0.1,0.4-0.2,0.3c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.2,0.2-0.2-0.1c0,0.2-0.1,0.3-0.1,0.5
    		c0-0.1,0-0.3,0-0.4c-0.1,0.4-0.2-0.1-0.2,0.3c0-0.2,0-0.3-0.1-0.5c0,0.4,0,0.5-0.1,0.2c0,0.1-0.1,0.4-0.1,0c0,0,0,0-0.1,0
    		c-0.1,0.1-0.1,0.3-0.2,0.1c-0.1,0.2-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.2,0c0,0,0,0.1,0,0.3c0-0.2-0.1-0.4-0.2-0.3c0,0,0,0,0,0
    		c-0.1-0.3-0.1-0.1-0.2,0.2c0-0.2-0.1-0.5-0.1-0.2c-0.1-0.1-0.2,0.3-0.3-0.1c0,0,0,0-0.1,0c-0.1,0.2-0.3,0.1-0.4,0.1
    		c0,0-0.1-0.1-0.1-0.2c0,0,0,0.2-0.1,0.2c0,0-0.1-0.1-0.1-0.1c0,0.1,0,0.2,0,0.2c0-0.1-0.1-0.2-0.1-0.3c0,0,0,0,0,0
    		c0,0.1-0.1,0.2-0.2,0.3c0-0.2,0-0.3,0-0.4c0,0,0,0.1-0.1,0.1c0,0.2-0.1,0.1-0.1,0.1c0,0-0.1,0-0.2,0.1c0,0,0-0.1,0-0.2
    		c0,0.1,0,0.2-0.1,0.3c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.4-0.2,0-0.2,0.2C10,23.7,9.9,23.9,9.8,24c0-0.1,0-0.2,0-0.3
    		c-0.1,0.2-0.1,0.2-0.2,0c0,0.1,0,0.1-0.1,0.2c0,0-0.1-0.1-0.1,0.1c0,0,0,0,0,0c-0.1-0.3-0.1-0.1-0.2,0c0,0,0,0-0.1,0
    		c0,0-0.1,0-0.1,0c0-0.3,0-0.3-0.1-0.3c0,0.1,0,0.2,0,0.3c0-0.1,0-0.2-0.1-0.4c0,0.1-0.1,0.2-0.1,0.3c0-0.3-0.1-0.3-0.1-0.2
    		c0,0-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0-0.1-0.2c0,0-0.1,0.1-0.1,0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0.4-0.1,0.2-0.2,0.1
    		c-0.1,0-0.1-0.1-0.2,0c0,0.1-0.1-0.1-0.2-0.1c0,0,0,0.1,0,0.2c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1-0.1-0.2c0,0.1,0,0.2-0.1,0.3
    		c-0.1-0.2-0.2-0.2-0.3,0.2c0-0.2,0-0.4,0-0.6c0,0.2-0.1,0.3-0.1,0.2c-0.1,0-0.1-0.1-0.2,0.1c0,0.1-0.1-0.1-0.1-0.1
    		c0,0-0.1,0.4-0.1,0c0,0.1-0.1-0.1-0.1,0.2c0,0.1,0,0.2,0,0.1c0,0,0,0.1,0,0.2c0,0,0-0.1,0-0.1c0,0,0,0.1-0.1,0.1
    		C6.3,24.4,6.3,24.6,6.3,24.8z M21.2,24.8c0-0.1,0-0.2,0.1-0.3C21.3,24.8,21.2,24.9,21.2,24.8z M20.9,24.3
    		C20.9,24.2,20.9,24.2,20.9,24.3C20.9,24.2,20.9,24.3,20.9,24.3C20.9,24.3,20.9,24.4,20.9,24.3C20.9,24.4,20.9,24.3,20.9,24.3z
    		 M20.5,24.6C20.5,24.6,20.6,24.6,20.5,24.6c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0C20.5,24.7,20.5,24.6,20.5,24.6z M20.2,24.4
    		c0.1,0,0.1,0,0,0.3C20.3,24.6,20.2,24.5,20.2,24.4z M19.2,25c0,0,0-0.1,0-0.2C19.2,24.9,19.2,24.9,19.2,25C19.2,25,19.2,25,19.2,25
    		C19.2,25.1,19.2,25,19.2,25z M19.1,24.3c0,0,0-0.1,0-0.1C19.1,24.2,19.1,24.2,19.1,24.3C19.1,24.3,19.1,24.3,19.1,24.3
    		C19.1,24.3,19.1,24.3,19.1,24.3z M18.6,24.8C18.6,24.8,18.6,24.7,18.6,24.8C18.6,24.7,18.6,24.8,18.6,24.8c0,0.1,0,0.1,0,0.1
    		C18.6,24.9,18.6,24.8,18.6,24.8z M14.8,24.7c0-0.1,0-0.1,0-0.3C14.9,24.7,14.9,24.8,14.8,24.7z M12.8,24.3c0.1-0.1,0.1,0,0.1,0.2
    		C12.8,24.7,12.8,24.5,12.8,24.3z"
            />
            <path fill={color} d="M14.7,25.8c0-0.1,0-0.1,0-0.3C14.7,25.8,14.7,25.8,14.7,25.8z" />
            <path
                fill={color}
                d="M12.6,25.6c-0.1,0.1-0.1-0.1-0.1-0.2C12.6,25.3,12.6,25.4,12.6,25.6z"
            />
            <path
                fill={color}
                d="M20.2,25.9c0,0,0,0.1,0,0.1C20.2,26,20.1,26,20.2,25.9c0,0,0,0,0-0.1C20.2,25.8,20.2,25.9,20.2,25.9z"
            />
            <path fill={color} d="M20.3,25.7c0-0.1,0-0.2,0-0.3C20.3,25.5,20.3,25.5,20.3,25.7z" />
            <path
                fill={color}
                d="M20.6,25.9C20.6,25.8,20.6,25.8,20.6,25.9c0-0.1,0-0.2,0-0.2c0,0,0,0,0,0C20.6,25.7,20.6,25.8,20.6,25.9z"
            />
            <path
                fill={color}
                d="M21,25.4C21,25.4,21,25.4,21,25.4C21,25.4,20.9,25.4,21,25.4c0,0,0-0.1,0-0.1C21,25.3,21,25.3,21,25.4z"
            />
            <path
                fill={color}
                d="M19.1,25.3c0,0,0,0.1,0,0.1C19.1,25.4,19,25.4,19.1,25.3c0,0,0-0.1,0-0.1C19.1,25.2,19.1,25.3,19.1,25.3z"
            />
            <path
                fill={color}
                d="M18.6,25.9c0,0,0,0.1,0,0.1C18.6,26,18.6,25.9,18.6,25.9c0-0.1,0-0.1,0-0.1C18.6,25.8,18.6,25.9,18.6,25.9z"
            />
            <path
                fill={color}
                d="M18,26.6C18,26.7,18,26.7,18,26.6C18,26.7,18,26.7,18,26.6c0,0,0-0.1,0-0.3C18,26.5,18,26.6,18,26.6z"
            />
            <path
                fill={color}
                d="M19.2,26c0,0,0,0.1,0,0.1C19.2,26.1,19.2,26.1,19.2,26c0,0,0,0,0-0.1C19.2,26,19.2,26,19.2,26z"
            />
            <path
                fill={color}
                d="M19.4,25.9c0,0,0,0.1,0,0.2C19.4,26,19.3,25.9,19.4,25.9c0,0,0-0.1,0-0.1C19.4,25.8,19.4,25.9,19.4,25.9z"
            />
            <path
                fill={color}
                d="M19.1,26.7C19.1,26.7,19.1,26.7,19.1,26.7C19.1,26.7,19.1,26.7,19.1,26.7c0,0,0-0.1,0-0.1
    		C19.1,26.6,19.1,26.6,19.1,26.7z"
            />
            <path
                fill={color}
                d="M18.2,13.9C18.2,13.9,18.2,13.9,18.2,13.9C18.2,13.9,18.2,13.9,18.2,13.9C18.3,13.9,18.3,13.9,18.2,13.9
    		C18.2,13.9,18.2,13.9,18.2,13.9z"
            />
            <path
                fill={color}
                d="M19.1,7.5C19.1,7.5,19.1,7.5,19.1,7.5C19.1,7.5,19.1,7.5,19.1,7.5C19.2,7.5,19.2,7.5,19.1,7.5
    		C19.1,7.5,19.1,7.5,19.1,7.5z"
            />
            <path
                fill={color}
                d="M4.7,12.8c0,0.1,0,0.2,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2,0
    		c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0,0.2,0
    		c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.4,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0c0,0,0,0,0.1,0
    		c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
    		c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0
    		c0,0,0,0,0,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0
    		c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
    		c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
    		c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0
    		c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
    		c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0
    		c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0,0.2,0
    		c0,0,0.1,0,0.1,0c0.1,0.1,0.2,0,0.2,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0
    		c0,0,0,0,0,0c0,0,0.1,0.1,0.2,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1-0.1c0.1,0,0-0.1,0.1-0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1
    		c0,0-0.1,0-0.2,0c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1c0,0.1-0.1,0.1-0.1,0.1
    		c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0.1,0,0.1-0.1,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.1c0,0.1,0,0.1-0.1,0.1
    		c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0.1c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0
    		c0,0,0,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.2,0.2c0,0,0,0.1-0.1,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1
    		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0,0-0.1,0.1-0.1,0.1
    		C15.1,16.9,15.1,17,15,17c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.2,0.2c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.1,0.1
    		c-0.1,0.1-0.2,0.2-0.3,0.3C14.1,18,14,18.1,14,18.2c0,0.1,0,0.2,0.1,0.2c0,0,0,0,0.1,0.1c0,0,0,0.1,0.1,0c0,0,0,0,0,0.1
    		c0,0.1,0,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0.1,0.1,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0.1,0
    		c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0
    		c0,0,0,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1
    		c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.2
    		c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0
    		c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1
    		c0,0,0,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0.1-0.1
    		c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.1
    		c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0.1,0,0-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1
    		c0,0,0,0,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0
    		c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.1
    		c0.1,0,0.1-0.1,0.2-0.2c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0.1,0c0,0,0.1-0.1,0.1-0.1
    		c0,0,0,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1-0.1
    		c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0.1-0.1,0.1-0.1
    		c0,0,0,0,0.1-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0
    		c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0
    		c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0
    		c0,0,0-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1-0.1
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1-0.1-0.1-0.1
    		c-0.1-0.1-0.2-0.2-0.3-0.3c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c0,0-0.1-0.1-0.1-0.1
    		c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1,0-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1-0.1
    		c0-0.1-0.1-0.1-0.2-0.2c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1-0.1-0.1
    		c0,0,0,0,0,0c0,0,0,0-0.1-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0
    		c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1-0.1c0,0.1,0,0.1,0.1,0.1
    		c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1L18,6.2
    		c0,0,0,0-0.1,0c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1L16,4.1
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0-0.1,0
    		c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0
    		c0,0,0,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2
    		c0,0.1,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.1,0.1C14.5,6,14.5,6,14.6,6.1c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1
    		c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1C15,6.5,15,6.5,15,6.5c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.1
    		c0,0,0,0,0,0C15.5,7,15.5,7,15.6,7.1c0,0,0,0,0,0c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0.1
    		c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0.1,0c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.1,0.1
    		c0,0,0.1,0,0.1,0.1c-0.1,0-0.1-0.1-0.2,0c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1
    		c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0.1,0.1c0,0.1,0.1,0.1,0.2,0.2
    		c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0.1,0.2,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0.1,0.1
    		c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0.1,0.1
    		c0,0,0,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1
    		c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0
    		c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0-0.2,0c0,0,0,0,0,0
    		c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0c0,0,0,0,0,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0
    		c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0
    		c-0.1,0-0.2,0-0.3,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3,0c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0
    		L11,10.5h-1c0,0,0,0,0,0H9c0,0,0,0,0,0H8.9c0,0,0,0,0,0c0,0,0,0,0,0H5.5c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.1,0.1
    		c0,0.1-0.1,0.1-0.2,0.2C5.1,10.9,5,10.9,5,11c0,0,0,0,0,0c0,0,0,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.2-0.1,0.2
    		c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0
    		c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1C4.7,12.7,4.7,12.7,4.7,12.8z
    		 M14.7,6.1C14.7,6.1,14.7,6.1,14.7,6.1C14.7,6.1,14.7,6.1,14.7,6.1C14.7,6,14.7,6,14.7,6.1C14.7,6,14.7,6,14.7,6.1z M14.8,4.8
    		c0,0,0,0.1,0,0.1C14.7,4.9,14.7,4.8,14.8,4.8C14.7,4.8,14.7,4.8,14.8,4.8C14.7,4.8,14.7,4.7,14.8,4.8C14.8,4.7,14.8,4.7,14.8,4.8z
    		 M15,5.9C15,5.9,15,6,15,5.9C14.9,6,14.9,6,15,5.9C14.9,5.9,15,5.9,15,5.9z M15.1,6.3C15.2,6.3,15.2,6.3,15.1,6.3
    		C15.2,6.4,15.2,6.4,15.1,6.3C15.1,6.4,15.1,6.3,15.1,6.3z M15.2,6.1C15.2,6.1,15.2,6.1,15.2,6.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0
    		C15.2,6.2,15.1,6.2,15.2,6.1C15.2,6.2,15.2,6.1,15.2,6.1C15.2,6.1,15.2,6.1,15.2,6.1z M15.3,6.1C15.2,6.1,15.2,6.1,15.3,6.1
    		C15.2,6.1,15.2,6,15.3,6.1C15.2,6,15.2,6,15.3,6.1z M15.3,6.4C15.3,6.4,15.3,6.4,15.3,6.4C15.3,6.4,15.3,6.4,15.3,6.4
    		C15.2,6.4,15.2,6.4,15.3,6.4C15.2,6.4,15.3,6.4,15.3,6.4z M15.4,6.2c0,0-0.1,0-0.1,0.1c-0.1,0,0-0.1-0.1-0.1
    		C15.3,6.2,15.4,6.1,15.4,6.2z M15.5,5.9C15.5,6,15.4,6,15.5,5.9C15.4,6,15.4,6,15.5,5.9C15.4,5.9,15.4,5.9,15.5,5.9
    		C15.5,5.9,15.5,5.9,15.5,5.9z M15.5,6.1C15.5,6.1,15.5,6.1,15.5,6.1C15.5,6,15.5,6,15.5,6.1C15.6,6.1,15.6,6.1,15.5,6.1z M15.7,6.5
    		C15.7,6.5,15.6,6.5,15.7,6.5C15.6,6.5,15.6,6.5,15.7,6.5C15.6,6.5,15.6,6.5,15.7,6.5c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0
    		c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0C15.6,6.4,15.6,6.4,15.7,6.5C15.6,6.4,15.6,6.4,15.7,6.5
    		C15.6,6.5,15.7,6.5,15.7,6.5z M15.7,6.3C15.7,6.3,15.8,6.3,15.7,6.3C15.8,6.3,15.8,6.3,15.7,6.3C15.7,6.4,15.7,6.4,15.7,6.3
    		C15.7,6.3,15.7,6.3,15.7,6.3C15.7,6.3,15.7,6.3,15.7,6.3z M15.8,5.2C15.8,5.2,15.7,5.2,15.8,5.2C15.7,5.2,15.7,5.2,15.8,5.2
    		C15.7,5.2,15.7,5.2,15.8,5.2C15.8,5.2,15.8,5.2,15.8,5.2C15.8,5.2,15.8,5.2,15.8,5.2z M16,4.7c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0,0,0,0,0C15.9,4.6,15.9,4.7,16,4.7z M16.8,7.6C16.8,7.6,16.8,7.6,16.8,7.6C16.8,7.6,16.8,7.6,16.8,7.6z M16.7,5.8
    		C16.7,5.8,16.8,5.8,16.7,5.8C16.8,5.8,16.8,5.8,16.7,5.8C16.8,5.8,16.7,5.8,16.7,5.8C16.7,5.8,16.7,5.8,16.7,5.8z M16.8,5.4
    		C16.8,5.4,16.7,5.4,16.8,5.4C16.7,5.3,16.8,5.3,16.8,5.4C16.8,5.4,16.8,5.4,16.8,5.4z M16.5,7.5C16.5,7.5,16.5,7.5,16.5,7.5
    		C16.5,7.5,16.5,7.5,16.5,7.5z M16.5,5.3C16.5,5.3,16.5,5.3,16.5,5.3C16.5,5.3,16.5,5.3,16.5,5.3C16.5,5.3,16.5,5.3,16.5,5.3z
    		 M16.4,7.7C16.4,7.7,16.4,7.7,16.4,7.7C16.4,7.7,16.5,7.7,16.4,7.7C16.5,7.7,16.5,7.7,16.4,7.7C16.4,7.7,16.4,7.7,16.4,7.7z
    		 M16.3,7.4C16.4,7.4,16.4,7.4,16.3,7.4C16.3,7.4,16.3,7.4,16.3,7.4z M16.3,6.7c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1
    		C16.4,6.8,16.3,6.7,16.3,6.7C16.3,6.7,16.3,6.7,16.3,6.7z M16.1,5.3c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1
    		C16.3,5.4,16.2,5.4,16.1,5.3c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1
    		C16.1,5.4,16.1,5.3,16.1,5.3z M16.3,4.9C16.3,4.9,16.2,4.9,16.3,4.9C16.2,4.9,16.2,4.9,16.3,4.9C16.3,4.8,16.3,4.8,16.3,4.9
    		c0.1,0,0.1,0,0.1,0C16.4,4.9,16.3,4.9,16.3,4.9z M16.2,4.6C16.2,4.6,16.2,4.6,16.2,4.6C16.1,4.6,16.2,4.6,16.2,4.6
    		C16.2,4.6,16.2,4.6,16.2,4.6z M16.4,4.8C16.4,4.8,16.4,4.8,16.4,4.8c-0.1,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0
    		C16.4,4.7,16.4,4.7,16.4,4.8z M16.7,5.2C16.7,5.2,16.7,5.2,16.7,5.2c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1c0,0,0-0.1,0-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0C16.6,5,16.6,5.1,16.7,5.2
    		C16.7,5.1,16.7,5.1,16.7,5.2z M16.7,6C16.7,6,16.7,6,16.7,6C16.7,6,16.7,6,16.7,6z M16.8,5C16.8,5,16.8,5,16.8,5
    		C16.7,5.1,16.7,5,16.8,5C16.7,5,16.8,5,16.8,5C16.8,4.9,16.8,4.9,16.8,5C16.8,5,16.8,5,16.8,5z M16.9,5.3
    		C16.8,5.3,16.8,5.3,16.9,5.3C16.8,5.3,16.8,5.3,16.9,5.3c-0.1-0.1-0.1-0.1-0.2-0.2c0.1,0,0.1,0,0.1,0.1C16.8,5.2,16.8,5.3,16.9,5.3
    		C16.9,5.3,16.9,5.3,16.9,5.3z M16.9,6.2C17,6.2,17,6.2,16.9,6.2c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0
    		c0,0,0-0.1,0-0.1C17,6.3,17,6.2,16.9,6.2C16.9,6.2,16.9,6.2,16.9,6.2C16.9,6.1,16.9,6.1,16.9,6.2z M17,5.7C17,5.7,17,5.8,17,5.7
    		C17,5.8,17,5.8,17,5.7z M17.2,5.6C17.1,5.6,17.1,5.6,17.2,5.6c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0
    		C17.1,5.5,17.1,5.5,17.2,5.6C17.2,5.6,17.2,5.6,17.2,5.6z M17.2,6.3C17.2,6.3,17.2,6.3,17.2,6.3C17.2,6.3,17.2,6.3,17.2,6.3z
    		 M17.2,6.9C17.2,6.9,17.2,6.9,17.2,6.9C17.2,6.9,17.2,6.9,17.2,6.9C17.2,6.9,17.2,6.9,17.2,6.9C17.2,6.9,17.2,6.9,17.2,6.9z
    		 M17.4,6.3C17.4,6.3,17.4,6.3,17.4,6.3C17.3,6.3,17.3,6.3,17.4,6.3c-0.1,0-0.1,0-0.1-0.1C17.3,6.2,17.3,6.2,17.4,6.3
    		C17.4,6.2,17.4,6.2,17.4,6.3z M17.6,6.8C17.6,6.8,17.6,6.8,17.6,6.8c-0.1,0-0.1-0.1-0.1-0.1C17.6,6.7,17.6,6.7,17.6,6.8z M17.7,6
    		C17.7,6,17.7,6.1,17.7,6C17.6,6,17.6,6,17.7,6C17.7,6,17.7,6,17.7,6z M18.7,9.6C18.7,9.5,18.7,9.5,18.7,9.6
    		C18.7,9.5,18.7,9.6,18.7,9.6z M18.6,9.3C18.7,9.3,18.7,9.3,18.6,9.3C18.6,9.4,18.6,9.4,18.6,9.3z M18.5,9.2
    		C18.5,9.1,18.5,9.1,18.5,9.2C18.4,9.1,18.4,9,18.4,9c0,0,0,0,0,0c0,0,0,0,0.1,0C18.5,9,18.5,9.1,18.5,9.2
    		C18.5,9.1,18.5,9.1,18.5,9.2C18.6,9.1,18.6,9.2,18.5,9.2C18.5,9.2,18.5,9.2,18.5,9.2z M18.5,8.9C18.5,8.9,18.5,8.9,18.5,8.9
    		C18.6,8.9,18.6,9,18.5,8.9C18.5,8.9,18.5,8.9,18.5,8.9z M18.5,8.5C18.5,8.5,18.5,8.4,18.5,8.5C18.5,8.4,18.5,8.4,18.5,8.5
    		C18.5,8.4,18.5,8.4,18.5,8.5C18.5,8.4,18.5,8.5,18.5,8.5z M18.4,8.6c0,0-0.1,0-0.1-0.1C18.3,8.5,18.3,8.5,18.4,8.6
    		C18.4,8.6,18.4,8.6,18.4,8.6C18.5,8.6,18.4,8.6,18.4,8.6z M18.4,9.6C18.4,9.6,18.4,9.6,18.4,9.6C18.5,9.7,18.4,9.7,18.4,9.6
    		C18.4,9.7,18.4,9.7,18.4,9.6z M18.4,9.3C18.4,9.3,18.4,9.3,18.4,9.3C18.4,9.3,18.4,9.3,18.4,9.3C18.4,9.3,18.4,9.3,18.4,9.3
    		C18.4,9.3,18.4,9.3,18.4,9.3z M18.3,9C18.3,9,18.3,9,18.3,9c-0.1,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1C18.3,8.9,18.3,8.9,18.3,9
    		C18.4,9,18.3,9,18.3,9z M17.9,8.9c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0,0.1,0.1c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0-0.1-0.1-0.1C18,9,18,9,17.9,8.9C17.9,8.9,17.9,8.9,17.9,8.9z M18.2,8.6
    		C18.2,8.5,18.2,8.5,18.2,8.6C18.2,8.5,18.2,8.5,18.2,8.6C18.2,8.5,18.2,8.5,18.2,8.6C18.2,8.5,18.2,8.5,18.2,8.6z M17.8,8.2
    		C17.8,8.2,17.8,8.2,17.8,8.2C17.8,8.3,17.8,8.2,17.8,8.2z M17.8,8.9C17.8,8.9,17.8,8.9,17.8,8.9C17.7,8.9,17.7,8.9,17.8,8.9
    		C17.7,8.9,17.7,8.9,17.8,8.9C17.7,8.9,17.8,8.9,17.8,8.9z M17.8,9C17.8,9,17.8,9,17.8,9C17.8,9,17.8,9,17.8,9c0,0.1,0,0.1,0,0.1
    		c0,0,0,0,0,0C17.7,9.1,17.7,9,17.8,9z M17.8,6.9C17.9,6.9,17.9,6.9,17.8,6.9C17.9,7,17.9,7,17.8,6.9C17.8,6.9,17.8,6.9,17.8,6.9z
    		 M17.9,6.6C17.9,6.6,17.9,6.6,17.9,6.6C17.9,6.6,17.9,6.6,17.9,6.6C17.9,6.6,17.9,6.6,17.9,6.6z M17.9,6.4
    		C17.9,6.4,17.9,6.4,17.9,6.4C18,6.4,17.9,6.4,17.9,6.4z M18,6.7C18,6.7,18,6.7,18,6.7c-0.1,0-0.1,0-0.1-0.1C18,6.7,18,6.7,18,6.7z
    		 M18,6.8C18,6.8,18,6.8,18,6.8C18,6.8,18,6.8,18,6.8C18,6.8,18,6.8,18,6.8C18,6.8,18,6.8,18,6.8z M18.1,6.3C18,6.4,18,6.4,18.1,6.3
    		C18,6.3,18,6.3,18.1,6.3C18,6.3,18,6.3,18.1,6.3C18.1,6.3,18.1,6.3,18.1,6.3z M18.1,7.2C18.1,7.2,18.1,7.2,18.1,7.2
    		C18.1,7.2,18.1,7.3,18.1,7.2C18.1,7.3,18,7.2,18.1,7.2C18,7.2,18,7.2,18.1,7.2C18,7.1,18,7.1,18.1,7.2C18,7.1,18,7.1,18.1,7.2
    		C18.1,7.1,18.1,7.1,18.1,7.2z M18.1,6.8C18.1,6.8,18.1,6.8,18.1,6.8C18.1,6.8,18.1,6.8,18.1,6.8C18.1,6.8,18.1,6.8,18.1,6.8
    		C18.1,6.8,18.1,6.8,18.1,6.8z M18.2,7.1C18.2,7.1,18.2,7.1,18.2,7.1C18.2,7.1,18.2,7.1,18.2,7.1C18.2,7,18.2,7,18.2,7.1
    		C18.2,7,18.2,7,18.2,7.1C18.2,7.1,18.2,7.1,18.2,7.1z M18.2,8.3C18.1,8.3,18.1,8.3,18.2,8.3C18.2,8.3,18.2,8.3,18.2,8.3z M18.3,7.6
    		C18.3,7.6,18.3,7.6,18.3,7.6c-0.1,0-0.1-0.1-0.1-0.1C18.3,7.5,18.3,7.5,18.3,7.6C18.3,7.6,18.4,7.6,18.3,7.6z M18.3,8.4
    		C18.3,8.4,18.3,8.3,18.3,8.4C18.3,8.3,18.3,8.3,18.3,8.4C18.4,8.3,18.4,8.4,18.3,8.4z M18.5,7.3c-0.1,0-0.1,0-0.1-0.1
    		C18.4,7.3,18.5,7.3,18.5,7.3z M18.5,7.2c0-0.1,0-0.1,0-0.1C18.5,7.1,18.5,7.1,18.5,7.2z M18.6,8.3c-0.1,0-0.1,0-0.1-0.1
    		C18.5,8.2,18.6,8.2,18.6,8.3C18.6,8.3,18.6,8.3,18.6,8.3z M18.7,8.6C18.7,8.6,18.6,8.6,18.7,8.6C18.7,8.5,18.7,8.6,18.7,8.6z
    		 M18.7,8.4C18.7,8.4,18.7,8.4,18.7,8.4C18.7,8.4,18.7,8.4,18.7,8.4C18.7,8.4,18.7,8.4,18.7,8.4C18.7,8.4,18.7,8.4,18.7,8.4z
    		 M18.8,8.8c0,0-0.1,0-0.1,0c0,0-0.1-0.1,0-0.1C18.7,8.7,18.7,8.7,18.8,8.8z M18.8,8.6C18.8,8.5,18.7,8.5,18.8,8.6
    		C18.8,8.5,18.8,8.5,18.8,8.6z M18.8,9C18.8,9,18.8,9,18.8,9C18.8,9,18.7,9,18.8,9C18.7,9,18.8,9,18.8,9z M18.9,9.8
    		C18.9,9.9,18.9,9.8,18.9,9.8C18.9,9.8,18.9,9.8,18.9,9.8z M19,9.5C19,9.5,18.9,9.5,19,9.5C18.9,9.5,18.9,9.5,19,9.5
    		C18.9,9.5,19,9.5,19,9.5z M22.2,12.5C22.2,12.5,22.2,12.5,22.2,12.5C22.2,12.5,22.2,12.5,22.2,12.5C22.2,12.5,22.2,12.5,22.2,12.5
    		C22.2,12.5,22.2,12.6,22.2,12.5C22.2,12.6,22.2,12.6,22.2,12.5z M21.9,12.5C21.9,12.5,21.9,12.5,21.9,12.5
    		C21.9,12.5,21.9,12.5,21.9,12.5C21.9,12.5,21.9,12.5,21.9,12.5C21.9,12.5,21.9,12.5,21.9,12.5z M21.6,11.7
    		C21.6,11.6,21.6,11.6,21.6,11.7C21.6,11.6,21.6,11.6,21.6,11.7C21.6,11.6,21.7,11.6,21.6,11.7C21.7,11.6,21.7,11.6,21.6,11.7
    		C21.6,11.6,21.6,11.6,21.6,11.7C21.6,11.6,21.6,11.6,21.6,11.7C21.6,11.7,21.6,11.7,21.6,11.7z M21.1,9.9
    		C21.1,9.8,21.1,9.8,21.1,9.9C21.1,9.8,21.1,9.8,21.1,9.9C21.1,9.8,21.1,9.9,21.1,9.9C21.1,9.9,21.1,9.9,21.1,9.9z M21,13.8
    		C21,13.8,21,13.8,21,13.8C21,13.8,21,13.8,21,13.8z M21,13.2C21,13.2,21,13.2,21,13.2c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0
    		C21,13.1,21,13.2,21,13.2z M21,9.4C20.9,9.4,20.9,9.4,21,9.4C20.9,9.4,20.9,9.4,21,9.4C20.9,9.3,20.9,9.3,21,9.4
    		C20.9,9.3,20.9,9.4,21,9.4z M20.9,14.1C20.9,14.1,20.9,14.1,20.9,14.1C20.9,14.1,20.9,14.1,20.9,14.1
    		C20.9,14.1,20.9,14.1,20.9,14.1C20.9,14.1,20.9,14.1,20.9,14.1z M20.8,13.9C20.8,13.9,20.8,13.9,20.8,13.9
    		C20.9,13.9,20.9,13.9,20.8,13.9z M20.7,10.3c-0.1,0-0.1-0.1-0.1-0.1C20.7,10.2,20.7,10.2,20.7,10.3z M20.6,12.4
    		C20.7,12.4,20.7,12.4,20.6,12.4C20.7,12.4,20.7,12.4,20.6,12.4z M20.6,12.2C20.6,12.2,20.6,12.2,20.6,12.2
    		C20.7,12.2,20.6,12.2,20.6,12.2C20.6,12.2,20.6,12.2,20.6,12.2C20.6,12.2,20.6,12.2,20.6,12.2z M20.5,14.1
    		C20.5,14,20.6,14,20.5,14.1C20.6,14,20.6,14,20.5,14.1z M20.4,8.8C20.4,8.8,20.4,8.8,20.4,8.8C20.4,8.8,20.4,8.8,20.4,8.8
    		C20.4,8.8,20.4,8.8,20.4,8.8C20.4,8.8,20.4,8.8,20.4,8.8z M20.5,10.5C20.5,10.5,20.5,10.5,20.5,10.5C20.5,10.5,20.4,10.5,20.5,10.5
    		C20.4,10.5,20.4,10.5,20.5,10.5C20.4,10.5,20.5,10.5,20.5,10.5z M20.3,12.8c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0
    		c0,0,0,0,0.1,0c0,0,0,0.1-0.1,0.1C20.4,12.7,20.4,12.7,20.3,12.8C20.4,12.7,20.3,12.8,20.3,12.8C20.3,12.8,20.3,12.8,20.3,12.8z
    		 M20.4,12.2C20.4,12.2,20.4,12.2,20.4,12.2C20.4,12.2,20.4,12.2,20.4,12.2z M20.2,12C20.2,12,20.2,12,20.2,12
    		c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0.1c0.1,0,0,0.1,0,0.1C20.3,12,20.3,12,20.2,12C20.3,12,20.2,12,20.2,12z M20.2,12.7
    		C20.2,12.7,20.2,12.7,20.2,12.7C20.2,12.7,20.2,12.7,20.2,12.7z M20.1,13.4C20.1,13.3,20.1,13.3,20.1,13.4
    		C20.1,13.3,20.2,13.3,20.1,13.4C20.2,13.3,20.2,13.4,20.1,13.4C20.2,13.4,20.1,13.4,20.1,13.4z M20,12.7C20,12.6,20,12.6,20,12.7
    		c0.1,0,0.1,0,0.1-0.1C20.1,12.6,20.1,12.7,20,12.7C20.1,12.7,20.1,12.7,20,12.7C20,12.7,20,12.7,20,12.7z M20,8.7
    		C20,8.7,20,8.7,20,8.7C20,8.7,20,8.7,20,8.7C20,8.7,20,8.7,20,8.7C20,8.7,20,8.7,20,8.7z M19.8,13.2c0,0,0.1-0.1,0.1-0.1
    		C19.9,13.1,19.8,13.1,19.8,13.2C19.8,13.2,19.8,13.2,19.8,13.2z M19.7,12.4C19.7,12.4,19.7,12.4,19.7,12.4
    		C19.7,12.4,19.7,12.5,19.7,12.4C19.7,12.5,19.7,12.5,19.7,12.4z M14.8,18.6C14.8,18.6,14.8,18.6,14.8,18.6
    		C14.8,18.6,14.8,18.6,14.8,18.6C14.8,18.6,14.8,18.6,14.8,18.6C14.8,18.6,14.8,18.6,14.8,18.6z M15,18.1C15,18.2,15,18.2,15,18.1
    		C15,18.1,15,18.1,15,18.1z M15.2,19C15.2,19,15.2,19,15.2,19C15.1,19,15.1,19,15,19.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1
    		C15,18.9,15.1,18.9,15.2,19C15.2,18.9,15.2,18.9,15.2,19z M16,18.6c0,0,0-0.1,0-0.1C16.1,18.6,16.1,18.6,16,18.6z M15.9,19
    		C16,19,16,18.9,15.9,19c0.1-0.1,0.1-0.1,0.1-0.1C16,19,16,19,15.9,19C16,19.1,16,19.1,15.9,19C16,19.1,15.9,19,15.9,19z M15.7,18.7
    		C15.7,18.7,15.7,18.7,15.7,18.7C15.7,18.7,15.7,18.8,15.7,18.7C15.6,18.7,15.6,18.7,15.7,18.7z M15.4,19.2c0-0.1,0-0.1,0.1-0.1
    		C15.5,19.1,15.5,19.2,15.4,19.2C15.4,19.2,15.4,19.2,15.4,19.2z M15.3,18.4C15.3,18.4,15.3,18.4,15.3,18.4
    		C15.3,18.4,15.3,18.4,15.3,18.4z M15.3,18.8C15.3,18.8,15.3,18.8,15.3,18.8C15.3,18.8,15.3,18.8,15.3,18.8z M15.3,19.3
    		C15.3,19.3,15.3,19.4,15.3,19.3C15.3,19.4,15.3,19.4,15.3,19.3C15.3,19.3,15.3,19.3,15.3,19.3z M15.5,18.9
    		C15.5,18.9,15.5,18.9,15.5,18.9c-0.1,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0C15.4,18.9,15.4,18.9,15.5,18.9
    		C15.5,18.8,15.5,18.8,15.5,18.9C15.5,18.8,15.5,18.9,15.5,18.9z M15.5,19.5C15.6,19.6,15.5,19.6,15.5,19.5
    		C15.5,19.6,15.5,19.6,15.5,19.5z M15.6,19.4C15.6,19.5,15.6,19.5,15.6,19.4C15.6,19.5,15.6,19.4,15.6,19.4
    		C15.6,19.4,15.6,19.4,15.6,19.4z M15.6,19.1C15.6,19.1,15.6,19.1,15.6,19.1C15.6,19.1,15.6,19.1,15.6,19.1
    		C15.6,19.1,15.6,19.1,15.6,19.1z M15.8,18c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0
    		C15.8,18.1,15.8,18.1,15.8,18c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c0-0.1,0-0.1,0.1-0.1C15.7,17.9,15.7,17.9,15.8,18
    		C15.8,18,15.8,18,15.8,18C15.8,18,15.8,18,15.8,18z M15.8,18.6C15.8,18.6,15.8,18.7,15.8,18.6C15.8,18.6,15.8,18.6,15.8,18.6z
    		 M15.9,18.8C15.9,18.8,15.8,18.8,15.9,18.8C15.8,18.8,15.8,18.8,15.9,18.8C15.9,18.8,15.9,18.8,15.9,18.8z M15.9,19
    		C15.9,19,15.9,19,15.9,19C15.9,19,15.9,19,15.9,19c0,0.1-0.1,0.1-0.1,0.1C15.8,19,15.8,19,15.9,19C15.8,18.9,15.8,18.9,15.9,19
    		C15.8,18.9,15.8,18.9,15.9,19C15.9,19,15.9,19,15.9,19z M15.9,18.5C15.9,18.5,15.9,18.5,15.9,18.5C16,18.5,15.9,18.5,15.9,18.5
    		C15.9,18.6,15.9,18.6,15.9,18.5C15.9,18.5,15.9,18.5,15.9,18.5z M16,17.6C16,17.6,16,17.6,16,17.6c0,0.1,0,0.1,0,0.1
    		C15.9,17.7,15.9,17.7,16,17.6C15.9,17.7,16,17.7,16,17.6z M16.1,17.6C16.1,17.6,16.1,17.6,16.1,17.6C16,17.6,16,17.6,16.1,17.6
    		C16,17.6,16,17.5,16.1,17.6C16,17.5,16.1,17.5,16.1,17.6C16.1,17.5,16.1,17.5,16.1,17.6z M16.1,19C16.1,19,16.2,19,16.1,19
    		c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0C16.2,19,16.2,19,16.1,19C16.1,19,16.1,19,16.1,19z M16.2,18.6C16.2,18.7,16.2,18.7,16.2,18.6
    		c0,0.1,0,0.1,0,0.1C16.2,18.8,16.1,18.7,16.2,18.6C16.1,18.7,16.2,18.7,16.2,18.6z M16.3,16.3C16.3,16.3,16.3,16.3,16.3,16.3
    		C16.2,16.3,16.2,16.2,16.3,16.3C16.3,16.2,16.3,16.2,16.3,16.3C16.3,16.2,16.3,16.3,16.3,16.3z M16.4,18.5
    		C16.5,18.5,16.5,18.5,16.4,18.5C16.5,18.6,16.5,18.6,16.4,18.5c0,0.1-0.1,0.1-0.1,0.2C16.3,18.6,16.3,18.6,16.4,18.5
    		C16.4,18.5,16.4,18.5,16.4,18.5z M16.5,15.8C16.5,15.8,16.5,15.8,16.5,15.8C16.5,15.8,16.4,15.8,16.5,15.8
    		C16.4,15.8,16.4,15.8,16.5,15.8C16.5,15.7,16.5,15.7,16.5,15.8z M16.6,17.9C16.6,17.9,16.6,17.9,16.6,17.9
    		C16.6,17.8,16.6,17.8,16.6,17.9C16.6,17.8,16.6,17.8,16.6,17.9C16.6,17.8,16.6,17.8,16.6,17.9z M16.6,18.2
    		C16.7,18.2,16.7,18.2,16.6,18.2C16.7,18.3,16.7,18.3,16.6,18.2C16.7,18.3,16.6,18.3,16.6,18.2C16.6,18.3,16.6,18.3,16.6,18.2z
    		 M16.7,17.2C16.7,17.2,16.7,17.3,16.7,17.2C16.7,17.3,16.6,17.3,16.7,17.2C16.6,17.2,16.7,17.2,16.7,17.2z M16.7,16.7
    		c0,0,0-0.1,0.1-0.1C16.7,16.6,16.7,16.7,16.7,16.7z M16.8,17.4C16.8,17.4,16.8,17.4,16.8,17.4C16.8,17.4,16.8,17.4,16.8,17.4
    		C16.9,17.4,16.9,17.4,16.8,17.4z M16.9,16.9C16.9,16.9,16.9,16.9,16.9,16.9C16.9,16.9,16.9,16.9,16.9,16.9
    		C16.9,16.9,16.9,16.9,16.9,16.9C16.9,16.9,16.9,16.9,16.9,16.9z M17,15.2C17,15.2,17,15.2,17,15.2C17,15.2,17,15.2,17,15.2
    		C16.9,15.2,16.9,15.2,17,15.2C17,15.2,17,15.2,17,15.2z M17.4,15.1C17.4,15.1,17.4,15.1,17.4,15.1C17.4,15.1,17.4,15.1,17.4,15.1
    		C17.4,15.1,17.4,15.1,17.4,15.1C17.4,15.1,17.4,15.1,17.4,15.1z M17.8,16.2C17.8,16.2,17.8,16.2,17.8,16.2
    		C17.7,16.2,17.7,16.2,17.8,16.2C17.8,16.2,17.8,16.2,17.8,16.2z M17.8,16.9C17.8,16.9,17.8,16.9,17.8,16.9
    		C17.9,16.9,17.9,16.9,17.8,16.9C17.9,16.9,17.9,16.9,17.8,16.9C17.9,17,17.9,17,17.8,16.9C17.8,16.9,17.8,16.9,17.8,16.9z
    		 M17.8,15.2C17.8,15.2,17.8,15.2,17.8,15.2c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0C18,15.1,17.9,15.2,17.8,15.2z M18.1,14.7
    		C18.1,14.8,18.1,14.8,18.1,14.7C18.1,14.7,18.1,14.7,18.1,14.7C18.1,14.7,18.1,14.7,18.1,14.7z M18.3,15.2
    		C18.2,15.3,18.2,15.3,18.3,15.2c-0.1,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0C18.2,15.3,18.2,15.3,18.3,15.2
    		C18.2,15.2,18.2,15.2,18.3,15.2z M18.3,15.4C18.3,15.4,18.3,15.4,18.3,15.4C18.3,15.4,18.3,15.4,18.3,15.4
    		C18.2,15.4,18.2,15.4,18.3,15.4z M18.5,15.9C18.5,15.9,18.5,15.9,18.5,15.9C18.4,15.9,18.4,15.9,18.5,15.9
    		C18.4,15.9,18.4,15.9,18.5,15.9z M18.5,16.2C18.5,16.3,18.5,16.3,18.5,16.2C18.5,16.2,18.5,16.2,18.5,16.2z M18.6,11.1
    		C18.5,11.1,18.5,11.1,18.6,11.1C18.5,11,18.5,11,18.6,11.1z M18.7,10.8C18.7,10.8,18.7,10.9,18.7,10.8c0,0.1,0,0.1-0.1,0.1
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0C18.6,10.9,18.7,10.9,18.7,10.8C18.7,10.8,18.7,10.8,18.7,10.8C18.6,10.8,18.6,10.8,18.7,10.8
    		C18.6,10.8,18.7,10.7,18.7,10.8C18.7,10.7,18.7,10.8,18.7,10.8z M19,11.2C19,11.2,19,11.2,19,11.2C19,11.2,18.9,11.2,19,11.2
    		C18.9,11.2,18.9,11.2,19,11.2C19,11.2,19,11.2,19,11.2z M18.9,14.8C18.9,14.8,18.9,14.8,18.9,14.8C18.9,14.8,18.9,14.8,18.9,14.8
    		C18.9,14.9,18.9,14.9,18.9,14.8C18.9,14.9,18.9,14.8,18.9,14.8z M18.9,15.4C18.8,15.4,18.8,15.4,18.9,15.4
    		C18.8,15.3,18.8,15.3,18.9,15.4C18.8,15.3,18.9,15.4,18.9,15.4z M18.9,13.7c0-0.1,0.1-0.1,0.1-0.1C19,13.7,18.9,13.8,18.9,13.7z
    		 M19,15C19,15,19,15,19,15c0.1-0.1,0.1-0.1,0.1,0C19,15,19,15,19,15C18.9,15,18.9,15,19,15z M19,11C19,11,19,11,19,11
    		C19,11,19,11,19,11z M19.1,14.7C19.1,14.8,19.1,14.8,19.1,14.7C19,14.8,19,14.7,19.1,14.7C19,14.7,19.1,14.7,19.1,14.7z M19.1,14
    		C19.1,14,19.1,13.9,19.1,14C19.1,14,19.1,14,19.1,14C19.1,14.1,19.1,14.1,19.1,14C19,14,19,14,19.1,14z M19.1,8.9
    		C19.1,9,19.1,9,19.1,8.9C19.1,9,19.1,9,19.1,8.9C19.1,9,19.1,9,19.1,8.9z M19.2,8.9C19.2,9,19.2,8.9,19.2,8.9
    		C19.2,8.9,19.2,8.9,19.2,8.9c-0.1-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0.1,0C19.2,8.9,19.2,8.9,19.2,8.9C19.2,8.9,19.2,8.9,19.2,8.9z
    		 M19.2,14.8C19.1,14.7,19.1,14.7,19.2,14.8C19.2,14.7,19.2,14.7,19.2,14.8z M19.2,14.9C19.2,14.9,19.2,14.9,19.2,14.9
    		C19.2,15,19.2,15,19.2,14.9C19.2,15,19.2,14.9,19.2,14.9C19.2,14.9,19.2,14.9,19.2,14.9z M19.4,13.6C19.4,13.6,19.4,13.6,19.4,13.6
    		c0,0.1-0.1,0.1-0.1,0.1c0,0,0,0,0,0C19.3,13.6,19.3,13.6,19.4,13.6C19.3,13.6,19.3,13.5,19.4,13.6C19.3,13.5,19.4,13.5,19.4,13.6
    		C19.4,13.5,19.4,13.6,19.4,13.6z M19.5,10.5C19.5,10.5,19.5,10.5,19.5,10.5C19.5,10.5,19.5,10.5,19.5,10.5
    		C19.5,10.5,19.5,10.5,19.5,10.5C19.5,10.6,19.5,10.6,19.5,10.5C19.5,10.5,19.5,10.5,19.5,10.5z M19.5,12.2
    		C19.5,12.2,19.5,12.2,19.5,12.2C19.5,12.2,19.5,12.2,19.5,12.2C19.4,12.2,19.4,12.2,19.5,12.2C19.5,12.2,19.5,12.2,19.5,12.2z
    		 M19.5,13C19.5,13,19.5,13,19.5,13C19.5,13,19.5,13,19.5,13C19.5,13,19.5,13,19.5,13z M19.4,12.9C19.4,12.8,19.4,12.8,19.4,12.9
    		C19.5,12.8,19.5,12.8,19.4,12.9z M19.4,13.1C19.4,13.1,19.4,13.2,19.4,13.1c-0.1,0,0-0.1,0-0.1C19.5,13.1,19.5,13.1,19.4,13.1z
    		 M19.4,12.8C19.4,12.8,19.3,12.8,19.4,12.8C19.3,12.7,19.3,12.7,19.4,12.8C19.3,12.7,19.4,12.7,19.4,12.8
    		C19.4,12.7,19.4,12.7,19.4,12.8z M19.4,13.2C19.4,13.2,19.4,13.2,19.4,13.2C19.4,13.2,19.3,13.2,19.4,13.2
    		C19.4,13.2,19.4,13.2,19.4,13.2C19.4,13.2,19.4,13.2,19.4,13.2z M19.2,13.3C19.2,13.3,19.2,13.3,19.2,13.3
    		C19.2,13.2,19.2,13.2,19.2,13.3C19.2,13.2,19.2,13.2,19.2,13.3C19.2,13.2,19.2,13.2,19.2,13.3z M19.2,11c0,0,0-0.1,0-0.1
    		c0,0,0,0,0.1,0C19.3,11,19.2,11,19.2,11z M19.2,13.5C19.2,13.5,19.2,13.5,19.2,13.5C19.2,13.5,19.2,13.5,19.2,13.5
    		C19.2,13.5,19.2,13.5,19.2,13.5C19.2,13.5,19.2,13.5,19.2,13.5C19.2,13.5,19.2,13.5,19.2,13.5z M19.3,8.4
    		C19.3,8.3,19.3,8.3,19.3,8.4C19.3,8.3,19.3,8.3,19.3,8.4C19.3,8.3,19.3,8.3,19.3,8.4z M19.4,10.8C19.4,10.8,19.3,10.9,19.4,10.8
    		C19.3,10.9,19.3,10.9,19.4,10.8c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0,0C19.2,10.8,19.3,10.8,19.4,10.8
    		C19.3,10.8,19.3,10.8,19.4,10.8z M19.4,12.5C19.4,12.5,19.4,12.4,19.4,12.5C19.4,12.4,19.4,12.4,19.4,12.5
    		C19.5,12.5,19.5,12.5,19.4,12.5C19.5,12.5,19.5,12.5,19.4,12.5c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0-0.1
    		c0,0,0,0-0.1,0C19.4,12.6,19.5,12.6,19.4,12.5C19.4,12.6,19.4,12.6,19.4,12.5C19.4,12.5,19.4,12.5,19.4,12.5z M19.6,8.8
    		c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0C19.4,8.7,19.5,8.7,19.6,8.8C19.6,8.8,19.6,8.8,19.6,8.8z M19.6,9.8
    		C19.6,9.8,19.6,9.8,19.6,9.8C19.6,9.8,19.6,9.8,19.6,9.8C19.6,9.8,19.6,9.8,19.6,9.8z M19.6,15.3C19.6,15.3,19.6,15.3,19.6,15.3
    		C19.6,15.3,19.6,15.3,19.6,15.3C19.6,15.3,19.6,15.3,19.6,15.3C19.6,15.3,19.6,15.3,19.6,15.3z M19.6,15.4
    		C19.6,15.4,19.6,15.4,19.6,15.4C19.6,15.4,19.6,15.4,19.6,15.4C19.6,15.4,19.6,15.5,19.6,15.4C19.6,15.5,19.6,15.5,19.6,15.4
    		C19.6,15.5,19.6,15.5,19.6,15.4z M19.5,14.7C19.5,14.6,19.5,14.6,19.5,14.7C19.6,14.6,19.6,14.7,19.5,14.7z M19.5,13.3
    		C19.5,13.3,19.5,13.3,19.5,13.3c0.1,0,0.1,0,0.1,0.1C19.5,13.4,19.5,13.4,19.5,13.3z M19.1,15.6C19.1,15.6,19.1,15.5,19.1,15.6
    		C19.1,15.5,19.2,15.5,19.1,15.6c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1
    		c0,0,0,0,0.1,0c0,0,0,0,0,0C19.2,15.6,19.2,15.6,19.1,15.6C19.1,15.6,19.1,15.6,19.1,15.6C19.1,15.6,19.1,15.6,19.1,15.6z M19,15.4
    		c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1C19.1,15.5,19.1,15.5,19,15.4C19,15.4,19,15.4,19,15.4z M19,15.7
    		C19,15.7,19,15.7,19,15.7C19,15.7,19,15.7,19,15.7C19,15.7,19,15.7,19,15.7C19,15.7,19,15.7,19,15.7z M18.9,16.1
    		C18.9,16,19,16,18.9,16.1C19,16.1,19,16.1,18.9,16.1C18.9,16.1,18.9,16.1,18.9,16.1z M18.8,15.5C18.8,15.5,18.8,15.5,18.8,15.5
    		c0-0.1,0-0.1,0.1-0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1C18.9,15.5,18.9,15.5,18.8,15.5C18.9,15.6,18.8,15.6,18.8,15.5
    		C18.8,15.6,18.8,15.6,18.8,15.5z M18.8,15.7C18.7,15.8,18.7,15.8,18.8,15.7C18.7,15.7,18.7,15.7,18.8,15.7z M18.6,15.9
    		C18.7,15.9,18.7,15.9,18.6,15.9C18.7,16,18.7,16,18.6,15.9z M18.6,15.4C18.6,15.4,18.6,15.4,18.6,15.4
    		C18.6,15.4,18.6,15.4,18.6,15.4C18.6,15.4,18.6,15.4,18.6,15.4z M18.6,14.9C18.6,14.9,18.6,14.9,18.6,14.9
    		C18.6,14.9,18.6,14.9,18.6,14.9z M18.7,15.1c0,0.1,0,0.1,0,0.1c0,0-0.1,0-0.1,0C18.6,15.1,18.7,15.1,18.7,15.1z M18.7,15
    		C18.7,15,18.7,15,18.7,15C18.7,15,18.7,15,18.7,15z M18.7,14.8C18.7,14.8,18.7,14.8,18.7,14.8C18.7,14.8,18.7,14.8,18.7,14.8
    		C18.7,14.8,18.7,14.8,18.7,14.8C18.7,14.8,18.7,14.8,18.7,14.8z M18.9,14.6c0,0.1,0,0.1-0.1,0.1c0,0,0-0.1,0-0.1
    		C18.8,14.6,18.8,14.6,18.9,14.6z M18.9,13.5c0,0,0.1,0.1,0,0.1C18.8,13.5,18.8,13.5,18.9,13.5z M18.8,11.5
    		C18.8,11.4,18.8,11.4,18.8,11.5C18.9,11.5,18.9,11.5,18.8,11.5z M18.8,11.1C18.8,11,18.8,11,18.8,11.1C18.8,11,18.8,11,18.8,11.1
    		C18.8,11,18.7,11,18.8,11.1c-0.1-0.1,0-0.1,0-0.1c0-0.1,0-0.1,0-0.1c0,0.1,0,0.1,0,0.1C18.8,11,18.8,11,18.8,11.1
    		C18.8,11,18.8,11.1,18.8,11.1C18.8,11.1,18.8,11.1,18.8,11.1C18.8,11.1,18.8,11.1,18.8,11.1z M18.7,11.1
    		C18.7,11.1,18.7,11.1,18.7,11.1C18.7,11.2,18.7,11.2,18.7,11.1C18.7,11.1,18.7,11.1,18.7,11.1z M18.7,11.4
    		C18.7,11.3,18.7,11.3,18.7,11.4C18.8,11.4,18.8,11.4,18.7,11.4z M18.6,13.1C18.6,13.1,18.6,13.1,18.6,13.1
    		C18.7,13.1,18.6,13.1,18.6,13.1z M18.5,11.9C18.6,11.9,18.6,11.9,18.5,11.9C18.5,11.9,18.5,11.9,18.5,11.9z M18.5,11.6
    		C18.5,11.6,18.5,11.6,18.5,11.6c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0C18.6,11.6,18.6,11.6,18.5,11.6
    		C18.5,11.6,18.5,11.6,18.5,11.6z M18.5,11.4C18.5,11.4,18.5,11.4,18.5,11.4C18.5,11.4,18.5,11.3,18.5,11.4c0.1-0.1,0.1-0.1,0.1-0.2
    		c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0C18.6,11.4,18.5,11.4,18.5,11.4C18.5,11.4,18.5,11.4,18.5,11.4
    		C18.5,11.4,18.5,11.4,18.5,11.4z M18.4,11.2C18.4,11.2,18.4,11.2,18.4,11.2C18.5,11.2,18.5,11.2,18.4,11.2
    		C18.5,11.2,18.5,11.3,18.4,11.2C18.5,11.3,18.5,11.3,18.4,11.2C18.4,11.3,18.4,11.3,18.4,11.2z M18.4,12.9
    		C18.4,12.9,18.4,12.9,18.4,12.9C18.4,12.9,18.4,12.9,18.4,12.9z M18.4,13C18.4,13,18.4,12.9,18.4,13C18.4,13,18.4,13,18.4,13
    		C18.4,13,18.4,13,18.4,13z M18,12.4C18,12.3,18,12.3,18,12.4C18,12.3,18,12.3,18,12.4C18,12.4,18,12.4,18,12.4z M17.7,12.5
    		C17.7,12.5,17.7,12.5,17.7,12.5C17.7,12.5,17.7,12.5,17.7,12.5c0.1,0,0.1,0,0.1,0C17.7,12.5,17.7,12.5,17.7,12.5
    		C17.7,12.5,17.7,12.5,17.7,12.5z M17.3,12.8C17.3,12.8,17.3,12.8,17.3,12.8C17.3,12.7,17.4,12.8,17.3,12.8
    		C17.4,12.8,17.3,12.8,17.3,12.8z M17.3,13C17.3,13,17.3,13,17.3,13C17.3,13,17.3,13,17.3,13C17.3,13,17.3,13,17.3,13z M17.1,13.2
    		C17.1,13.2,17.1,13.2,17.1,13.2C17.2,13.2,17.2,13.2,17.1,13.2c0.1,0,0.2,0,0.2,0c0,0,0,0,0,0C17.3,13.2,17.2,13.3,17.1,13.2
    		C17.1,13.2,17.1,13.2,17.1,13.2z M17,12.6C17,12.6,17,12.6,17,12.6C17,12.6,17,12.6,17,12.6C17,12.6,17,12.6,17,12.6
    		C17,12.6,17,12.6,17,12.6C17,12.6,17,12.6,17,12.6z M16.8,11.9C16.8,11.9,16.8,11.9,16.8,11.9C16.8,11.9,16.8,11.9,16.8,11.9
    		C16.8,11.9,16.8,11.9,16.8,11.9C16.8,12,16.8,12,16.8,11.9C16.8,12,16.8,11.9,16.8,11.9z M16.2,12C16.2,12,16.2,11.9,16.2,12
    		C16.3,11.9,16.3,11.9,16.2,12C16.3,12,16.3,12,16.2,12C16.3,12,16.3,12,16.2,12z M16,11.8C16.1,11.9,16.1,11.9,16,11.8
    		C16.1,11.9,16.1,11.9,16,11.8C16.1,11.9,16.1,11.9,16,11.8C16.1,11.9,16.1,11.9,16,11.8C16.1,11.9,16.1,11.9,16,11.8
    		C16.1,11.9,16.1,11.9,16,11.8z M12,12.5C12,12.5,12,12.5,12,12.5C12,12.5,12,12.5,12,12.5C12,12.5,12,12.5,12,12.5
    		C12,12.5,12,12.5,12,12.5C12,12.6,12,12.6,12,12.5C12,12.6,12,12.6,12,12.5z M11.7,12.6C11.7,12.6,11.7,12.6,11.7,12.6
    		C11.7,12.6,11.7,12.5,11.7,12.6C11.7,12.5,11.7,12.5,11.7,12.6C11.7,12.5,11.7,12.6,11.7,12.6z M11.9,12
    		C11.9,12.1,11.8,12.1,11.9,12C11.8,12,11.8,12,11.9,12C11.8,12,11.9,12,11.9,12C11.9,12,11.9,12,11.9,12z M11.8,12.5
    		C11.8,12.5,11.8,12.5,11.8,12.5C11.8,12.5,11.8,12.5,11.8,12.5C11.9,12.5,11.9,12.5,11.8,12.5C11.9,12.5,11.9,12.6,11.8,12.5
    		C11.9,12.6,11.9,12.6,11.8,12.5C11.9,12.6,11.9,12.6,11.8,12.5C11.8,12.6,11.8,12.6,11.8,12.5z M11.6,12.9
    		C11.6,12.9,11.6,12.8,11.6,12.9C11.6,12.8,11.7,12.8,11.6,12.9c0.1-0.1,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0,0,0,0.1
    		C11.7,12.9,11.7,12.9,11.6,12.9C11.7,12.9,11.6,12.9,11.6,12.9z M11.4,12.9C11.4,12.8,11.4,12.8,11.4,12.9
    		C11.5,12.9,11.5,12.9,11.4,12.9C11.5,12.9,11.5,12.9,11.4,12.9z M11.2,10.7C11.2,10.7,11.2,10.7,11.2,10.7
    		C11.2,10.7,11.2,10.7,11.2,10.7C11.2,10.7,11.2,10.7,11.2,10.7z M11.2,12.3C11.2,12.3,11.2,12.3,11.2,12.3
    		C11.2,12.3,11.2,12.3,11.2,12.3C11.2,12.3,11.2,12.3,11.2,12.3C11.2,12.3,11.2,12.3,11.2,12.3z M8.6,12.9
    		C8.6,12.9,8.6,12.9,8.6,12.9C8.6,12.9,8.6,12.9,8.6,12.9C8.6,12.9,8.6,12.9,8.6,12.9z M8.6,10.6C8.6,10.6,8.6,10.6,8.6,10.6
    		C8.6,10.6,8.6,10.7,8.6,10.6C8.6,10.7,8.6,10.7,8.6,10.6z M8,12.3C8,12.3,8,12.3,8,12.3C8,12.3,8,12.3,8,12.3
    		C8.1,12.3,8.1,12.4,8,12.3C8,12.4,8,12.4,8,12.3C8,12.4,8,12.4,8,12.3z M7.8,10.9C7.8,11,7.8,11,7.8,10.9C7.8,11,7.8,11,7.8,10.9z
    		 M7.7,11.4C7.7,11.4,7.8,11.4,7.7,11.4C7.8,11.5,7.7,11.5,7.7,11.4z M7.6,11.2C7.6,11.2,7.6,11.2,7.6,11.2
    		C7.6,11.2,7.6,11.2,7.6,11.2C7.6,11.2,7.6,11.2,7.6,11.2C7.6,11.2,7.6,11.2,7.6,11.2z M7.6,10.6C7.6,10.6,7.6,10.6,7.6,10.6
    		c0.1,0.1,0.2,0,0.2,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0.1-0.1,0.1C7.6,10.8,7.6,10.8,7.6,10.6C7.6,10.7,7.6,10.7,7.6,10.6z
    		 M6.4,10.6C6.4,10.7,6.4,10.7,6.4,10.6c-0.1,0.1-0.1,0-0.2,0c0,0,0,0,0,0C6.3,10.6,6.4,10.6,6.4,10.6z M6.7,12.4
    		C6.7,12.5,6.7,12.5,6.7,12.4C6.6,12.5,6.6,12.5,6.7,12.4C6.6,12.5,6.6,12.5,6.7,12.4C6.6,12.4,6.6,12.4,6.7,12.4z M6.7,11.3
    		c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0
    		c0,0,0,0,0,0c0,0-0.1,0-0.1,0C6.7,11.4,6.7,11.3,6.7,11.3z M6.8,12.5C6.8,12.5,6.9,12.5,6.8,12.5C6.8,12.5,6.8,12.6,6.8,12.5
    		C6.7,12.5,6.7,12.5,6.8,12.5z M6.9,11C6.9,11,7,11,6.9,11C7,11,7,11,6.9,11C6.9,11,6.9,11,6.9,11z M7,10.6C7,10.6,7,10.6,7,10.6
    		c-0.1,0-0.1-0.1-0.1-0.1C6.9,10.5,6.9,10.5,7,10.6C6.9,10.5,7,10.5,7,10.6C7,10.5,7,10.5,7,10.6z M7,10.7c0,0,0,0.1,0.1,0.1
    		c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.2c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
    		c0,0-0.1,0-0.1,0c0-0.1,0-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0C7,10.7,7,10.7,7,10.7z M7.3,11.3C7.4,11.3,7.4,11.3,7.3,11.3
    		C7.4,11.3,7.4,11.4,7.3,11.3z M7.3,10.7C7.2,10.7,7.2,10.7,7.3,10.7c-0.1,0-0.2,0-0.2,0C7.1,10.6,7.2,10.6,7.3,10.7
    		C7.2,10.7,7.2,10.7,7.3,10.7C7.3,10.7,7.3,10.7,7.3,10.7C7.3,10.8,7.3,10.8,7.3,10.7z M7.2,12.5C7.2,12.5,7.2,12.5,7.2,12.5
    		c0,0.1,0,0.1,0,0.1C7.2,12.6,7.2,12.6,7.2,12.5C7.1,12.5,7.1,12.5,7.2,12.5C7.2,12.5,7.2,12.5,7.2,12.5z M7.3,10.8
    		C7.3,10.8,7.3,10.8,7.3,10.8C7.3,10.9,7.3,10.9,7.3,10.8C7.2,10.8,7.2,10.8,7.3,10.8z M7,12.7C7,12.7,7,12.7,7,12.7
    		c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1
    		c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0C7.1,12.9,7.1,12.8,7,12.7C7,12.8,7,12.8,7,12.7z M6.9,11.6C6.9,11.5,7,11.5,6.9,11.6
    		C7,11.6,7,11.6,6.9,11.6z M6.9,13.1C6.9,13,6.9,13,6.9,13.1C6.9,13,6.9,13,6.9,13.1C6.9,13,6.9,13.1,6.9,13.1
    		C6.9,13.1,6.9,13.1,6.9,13.1z M6.7,12.8c0-0.1,0.1-0.2,0.2-0.2c0,0.1-0.1,0.1,0,0.2C6.8,12.9,6.7,12.8,6.7,12.8z M6.7,13
    		C6.7,13,6.7,13,6.7,13C6.8,13,6.8,13.1,6.7,13C6.7,13.1,6.7,13.1,6.7,13z M6.6,12.8C6.5,12.8,6.6,12.8,6.6,12.8
    		C6.6,12.8,6.6,12.8,6.6,12.8c0.1,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0C6.6,12.9,6.6,12.9,6.6,12.8C6.6,12.9,6.6,12.9,6.6,12.8z M6.5,12.7
    		C6.5,12.7,6.5,12.7,6.5,12.7C6.6,12.8,6.6,12.8,6.5,12.7C6.5,12.8,6.5,12.7,6.5,12.7z M6.3,10.9c0.1-0.1,0.1-0.1,0.2-0.1
    		c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0-0.1,0.1C6.4,10.9,6.3,10.9,6.3,10.9z M6.3,11.6C6.3,11.6,6.2,11.6,6.3,11.6
    		C6.2,11.6,6.2,11.6,6.3,11.6C6.2,11.5,6.3,11.5,6.3,11.6C6.3,11.5,6.3,11.6,6.3,11.6C6.3,11.6,6.3,11.6,6.3,11.6z M6.1,12.9
    		C6.2,12.8,6.2,12.8,6.1,12.9c0.1-0.1,0.1,0,0.1,0C6.2,12.9,6.2,12.9,6.1,12.9z M6.1,10.8C6.1,10.7,6.1,10.7,6.1,10.8
    		C6.1,10.7,6.2,10.7,6.1,10.8C6.1,10.7,6.1,10.7,6.1,10.8z M6.1,13.2C6.1,13.2,6.1,13.2,6.1,13.2C6.1,13.2,6.1,13.1,6.1,13.2
    		C6.1,13.2,6.1,13.2,6.1,13.2C6.1,13.2,6.1,13.2,6.1,13.2z M5.9,11C5.9,11,5.9,11,5.9,11c0.1-0.1,0.1-0.1,0.2,0C6,11,6,11,5.9,11
    		C5.9,11,5.9,11,5.9,11C5.9,11,5.9,11,5.9,11z M5,12C5,12,5,12,5,12c0.1,0,0.1,0.1,0.2,0.1c0,0-0.1,0-0.1,0C5,12.1,5,12.1,5,12
    		C5,12.1,5,12,5,12z"
            />
        </g>
    </svg>
);

Arrow.propTypes = propTypes;
Arrow.defaultProps = defaultProps;

export default Arrow;
